import React, { Component } from 'react';
import "./ThreeCanvas.css";

import * as THREE from "three";
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { BaseScene } from './basescene';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader';
import CSG from "./three-csg.js"
import { Utils } from './utils';
// import { GUI } from 'dat.gui';
import { DiffPatcher } from 'jsondiffpatch';
import { ThreeUtils } from './ThreeUtils';
import { Mesh, Vector2 } from 'three';
import { ModelManager } from './ModelManager';
import { getApiHostUrl } from "../settings";
import threeSpritetext from 'three-spritetext';

interface MyProps {
    canvasView: any;

    // neu
    shape: any;
    selectableTypes: any;
    interiors: any;
    walls: any;
    setSelectedInteriorId: any;
    setInteriorPosition: any;
    setInteriorSize: any;
    products: any;
    setSelectedProductIndex: any;
    setProductPosition: any;
    setSelectedProductId: any;
    focusedProductId: any;
    cameraIndex: number;
    setCameraIndex: any;
    updateElements: any;
    updateProducts: any;
    updateWall: any;
}

interface MyState {
    value: string
}

class ThreeCanvas extends Component<MyProps, MyState> {
    SERVERURL = getApiHostUrl() + "resources";
    renderer = new THREE.WebGLRenderer({ antialias: true });
    scene: THREE.Scene;
    meshes: any[] = [];
    productmeshes: any[] = [];

    objectboxes: any[] = [];
    selectBoxHelper: THREE.Box3Helper;
    camera: any;
    controls: any; // THREE.Control;
    raycaster: THREE.Raycaster;
    mouse = new THREE.Vector2();
    baseScene: BaseScene;

    INTERSECTED = null;
    canvasTarget: any;
    guistate: any;
    ceiling: any;
    viewpoints = [];
    loader: GLTFLoader;
    modelManager: ModelManager;

    constructor(props: MyProps | Readonly<MyProps>) {
        super(props);

        this.state = {
            value: 'test',
        };

        this.guistate = {

            background: false,
            bgColor1: '#ffffff',
            bgColor2: '#ffffff',
            dirLight: 0,
            exposure: 0,
            ambientColor: '#ffffff',
            ambientIntensity: 0.31,
            directColor: '#ffffff',
            directIntensity: 0,
            envMapItensity: 0.59,
            environment: '',
            wallColor: '#e8e8e8',
            wallEmissive: '#2d2d2d',
            wallSpecular: '#cccccc',
            spotLightColor: '#f7decf',
            spotLightDecay: 0,
            spotLightPenumbra: 0.42,
            spotLightItensity: 0.21,
            directionLightColor: '#ffffff',
            directionLightItensity: 0,
            fov: 45,
            param1: 1,
            param2: 1,
            param3: 1,
            pointLightColor: '#f7decf',
            pointLightDecay: 1,
            pointLightDistance: 100000,
            pointLightItensity: 0.4


        }


        // const gui = this.gui = new GUI({ autoPlace: true, width: 260, hideable: false });
        // const dispFolder = gui.addFolder('Lights');
        // const envBackgroundCtrl = dispFolder.add(this.guistate, 'background');
        // const bgColor1Ctrl = dispFolder.addColor(this.guistate, 'ambientColor');
        // bgColor1Ctrl.onChange(() => this.baseScene.ambientLight.color.set(this.guistate.ambientColor));
        // const ambientLightCtrl = dispFolder.add(this.guistate, 'ambientIntensity', 0, 1);
        // ambientLightCtrl.onChange(() => this.updateObjects());

        THREE.Cache.enabled = true;

        this.loader = new GLTFLoader();
        this.initScene();
        this.mouse = new THREE.Vector2(1, 1);
    }

    initScene() {
        this.camera = new THREE.PerspectiveCamera(85, window.innerWidth / window.innerHeight, 1, 20000);

        this.scene = new THREE.Scene();
        console.log('constr scene', this.scene)
        this.baseScene = new BaseScene(this.scene, this.renderer);
        this.meshes.push(this.baseScene.baseplane);

    }

    updateObjects() {

        this.baseScene.ambientLight.intensity = this.guistate.ambientIntensity;
        this.scene.traverse((child) => {
            var node = child as any;
            if (node.material && (node.material.isMeshStandardMaterial ||
                (node.material.isShaderMaterial && node.material.envMap !== undefined))) {
                node.material.envMapIntensity = this.guistate.envMapItensity; // boombox seems too dark otherwise
            }
        });

        //
        for (var i = 0; i < this.meshes.length; i++) {
            if (this.meshes[i].userData.isbuilding) {
                if (this.meshes[i].material) {
                    this.meshes[i].material.color = new THREE.Color(this.guistate.wallColor);
                    this.meshes[i].material.emissive = new THREE.Color(this.guistate.wallEmissive);
                    this.meshes[i].material.specular = new THREE.Color(this.guistate.wallSpecular);
                }

            }
        }

    }

    mousetrailRef;
    animationRequestID;


    async clearScene() {
        this.meshes = [];
        this.productmeshes = [];

        this.objectboxes = [];
        this.cutHelpers = [];
        try {
            //            this.scene.traverse(x => {
            try {

                for (var i = this.scene.children.length - 1; i > -1; i--) {
                    var x = this.scene.children[i];
                    //    if (x.type == "Mesh" || x.type == "Group" || x.type == "Box3Helper") {
                    console.log('remove', x);
                    this.scene.remove(x);
                    //   }

                }
            } catch (err) { }
            //          });

        }
        catch (er) { }
        console.log('scnee', this.scene);
    }



    async componentDidMount() {
        console.log('componentDidMount', this.props)
        this.mousetrailRef = React.createRef()

        const canvasTarget = document.getElementById('canvas');
        this.canvasTarget = canvasTarget;

        // https://discourse.threejs.org/t/how-to-animation-switch-camera-from-perspective-to-orthographic-like-3d-program-maya-blender-unity-etc-in-three-js/9470
        this.renderer.setSize(canvasTarget.clientWidth, canvasTarget.clientHeight);
        this.renderer.shadowMap.enabled = true; // https://threejsfundamentals.org/threejs/lessons/threejs-shadows.html
        this.renderer.shadowMap.autoUpdate = true;
        this.renderer.shadowMap.needsUpdate = false;
        this.renderer.shadowMap.type = THREE.PCFSoftShadowMap; //.PCFSoftShadowMap;
        // https://discoverthreejs.com/tips-and-tricks/
        //    this.renderer.gammaOutput = true;
        this.renderer.gammaFactor = 2.0;
        this.renderer.outputEncoding = THREE.sRGBEncoding;
        canvasTarget.appendChild(this.renderer.domElement);

        this.camera = new THREE.OrthographicCamera(window.innerWidth / - 2, window.innerWidth / 2, window.innerHeight / 2, window.innerHeight / - 2, 1, 1);

        this.modelManager = new ModelManager();
        if (this.props.selectableTypes.includes('product')) {
            await this.modelManager.loadBasicGltfs();
        }
        // erstellt den Raum, TODO: objekte laden
        await this.createRoom();
        await this.createInteriors(this.props.selectableTypes);


        (this.canvasTarget as any).addEventListener('pointerdown', this.sceneMouseDown.bind(this));
        (this.canvasTarget as any).addEventListener("pointermove", this.mousemoveCanvas.bind(this));
        (this.canvasTarget as any).addEventListener('pointerup', this.sceneMouseUp.bind(this));
        (this.canvasTarget as any).addEventListener('wheel', this.mouseWheel.bind(this));

        document.getElementById('canvasControlZoomIn').addEventListener('click', this.zoomIn.bind(this));
        document.getElementById('canvasControlZoomOut').addEventListener('click', this.zoomOut.bind(this));
        document.getElementById('canvasControlZoomFit').addEventListener('click', this.zoomFit.bind(this));
        document.getElementById('canvasControlPanTop').addEventListener('click', this.panTop.bind(this));
        document.getElementById('canvasControlPanDown').addEventListener('click', this.panDown.bind(this));
        document.getElementById('canvasControlPanLeft').addEventListener('click', this.panLeft.bind(this));
        document.getElementById('canvasControlPanRight').addEventListener('click', this.panRight.bind(this));
        document.addEventListener("solutionLoaded", this.roomLoaded.bind(this));
        document.addEventListener("focusItem", (event: any) => { this.setFocusedProduct(event.detail) });


        (window).addEventListener('resize', () => { this.resize() })
        this.raycaster = new THREE.Raycaster();

        // render loop
        var animate = () => {
            this.animationRequestID = requestAnimationFrame(animate);
            this.renderer.render(this.scene, this.camera);
        };

        animate();

        this.updateObjects();


        if (this.props?.canvasView == "3d")
            this.innerView();
        else {
            // var c = localStorage.getItem('camerapos');
            var camerapos = null;
            // if (c)
            //     camerapos = JSON.parse(c);

            // var z = localStorage.getItem('camerazoom');
            var camerazoom = null;
            // if (z)
            //     camerazoom = JSON.parse(z);

            this.orthoView(camerapos, camerazoom);
        }
        if (this.props.canvasView == "3d") {
            // var ci = this.viewpoints.length - this.props?.cameraIndex;
            // if (ci == this.viewpoints.length) ci = 0;
            var ci = this.props?.cameraIndex - 1; // this.viewpoints.length - diff?.cameraIndex[1];
            if (this.isopenRoom) {// offener Raum
                ci = this.props?.cameraIndex - 1;
                if (ci == -1)
                    ci = 3;
            }
            // if (ci == this.viewpoints.length) ci = 0;
            // if (this.props.walls.length === 3) {// offener Raum
            //     ci = diff?.cameraIndex[1] - 1;
            //     if (ci == -1) ci = 3;
            // }
            this.setCamera(this.viewpoints[ci]);
            // this.setCamera(this.viewpoints[0]);


        }
        this.resize();
    }

    async roomLoaded() {
        console.log('#roomLoaded', this.props);
        window.location.reload();
        // this.objectboxes = [];
        // this.cutHelpers = [];
        // //  this.meshes = [];
        //this.clearScene();
        // await this.createWalls(this.props.walls);
        // // await this.createRoom();

        // await this.createInteriors(this.props.selectableTypes);
        // this.updateObjects();


    }

    setFocusedProduct(productid: string) {
        console.log('focusitem', productid);
        var found = false;
        this.scene.traverse(x => {
            if (x?.userData?.type === "produkt") {
                if (x.userData?.product?.id === productid) {
                    var obj = x;

                    if (!found) {
                        var newviewpoint = ThreeUtils.getOppositeCamera(this.viewpoints, obj, this.props.walls, this.scene, this.camera);
                        this.setCamera(newviewpoint);
                        ThreeUtils.toScreenPosition(obj, this.camera, this.renderer, this.controls);
                        found = true;
                        this.selectedobject = obj;
                        this.setSelectedObject(obj, 0xFF6600);
                    }
                    return;
                }
            }
        })
    }

    resize() {
        this.renderer.setSize(this.canvasTarget.clientWidth, this.canvasTarget.clientHeight);
        if (this.camera) {
            if (this.props.canvasView == "2d") {
                var aspect = this.canvasTarget.clientWidth / this.canvasTarget.clientHeight;
                var frustumSize = 815;

                this.camera.left = - frustumSize * aspect / 2;
                this.camera.right = frustumSize * aspect / 2;
                this.camera.top = frustumSize / 2;
                this.camera.bottom = - frustumSize / 2;
            }

            this.camera.aspect = this.canvasTarget.clientWidth / this.canvasTarget.clientHeight;
            this.camera.updateProjectionMatrix();


        }
        else {
            console.log('no camera');
        }
    }

    zoomFit($event) {
        console.log('zoomFit', $event);
        var bb = ThreeUtils.getRoomBB(this.props.walls);

        this.camera.position.x = -bb.depth / 2;// 0;// -200;
        this.camera.position.y = this.props.walls[0].h + 10;// ; // TODO: weiter öffnen, je nach größe des
        this.camera.position.z = -bb.width / 2;// 0;// bb.width; // -250;
        this.camera.rotation.z = Math.PI;
        this.camera.zoom = 0.3 + 500 / bb.largest; // 0.5;
        this.camera.updateProjectionMatrix();
        this.controls.target = new THREE.Vector3(this.camera.position.x, 0, this.camera.position.z)
        this.controls.update();
    }
    zoomIn($event) {
        console.log('zoomIn.. ', this.camera.zoom, $event);
        if (this.props.canvasView == "3d") {
            this.camera.fov -= 300 / 48.0;
            if (this.camera.fov < 45) this.camera.fov = 45;
            if (this.camera.fov > 110) this.camera.fov = 110;

            this.camera.updateProjectionMatrix();

        } else {
            this.camera.zoom += 0.2;
            this.camera.updateProjectionMatrix();
            this.controls.target = new THREE.Vector3(this.camera.position.x, 0, this.camera.position.z)
            this.controls.update();
        }
        localStorage.setItem('camerazoom', JSON.stringify(this.camera.zoom));
    }
    zoomOut($event) {
        console.log('zoomOut', $event);
        if (this.props.canvasView == "3d") {
            this.camera.fov += 300 / 48.0;
            if (this.camera.fov < 45) this.camera.fov = 45;
            if (this.camera.fov > 110) this.camera.fov = 110;

            this.camera.updateProjectionMatrix();
        } else {
            this.camera.zoom -= 0.2;
            this.camera.updateProjectionMatrix();
            this.controls.target = new THREE.Vector3(this.camera.position.x, 0, this.camera.position.z)
            this.controls.update();
            localStorage.setItem('camerazoom', JSON.stringify(this.camera.zoom));
        }
    }
    panTop($event) {
        if (this.props.canvasView == "3d") {
            this.controls.target = new THREE.Vector3(this.controls.target.x, this.controls.target.y + 0.1, this.controls.target.z);
            this.controls.update();


        } else {

            this.camera.position.x += 10;
            this.camera.lookAt(this.camera.position.x, 0, this.camera.position.z);
            this.camera.updateProjectionMatrix();
            this.controls.target = new THREE.Vector3(this.camera.position.x, 0, this.camera.position.z)
            this.controls.update();
            console.log('panTop', this.camera);
        }
    }
    panDown($event) {
        if (this.props.canvasView == "3d") {
            this.camera.up = new THREE.Vector3(0, 1, 0)
            if (this.controls) {
                this.controls.target = new THREE.Vector3(this.controls.target.x, this.controls.target.y - 0.1, this.controls.target.z);
                this.controls.update();
            }
        } else {

            this.camera.position.x -= 10;
            this.camera.lookAt(this.camera.position.x, 0, this.camera.position.z);
            this.camera.updateProjectionMatrix();
            this.controls.target = new THREE.Vector3(this.camera.position.x, 0, this.camera.position.z)
            this.controls.update();
            console.log('panDown', this.camera);
        }
    }
    panLeft($event) {
        if (this.props.canvasView == "3d") {
            var nt = new THREE.Vector2(this.controls.target.x, this.controls.target.z).rotateAround(new THREE.Vector2(this.camera.position.x, this.camera.position.z), -0.1);

            this.controls.target = new THREE.Vector3(nt.x, this.controls.target.y, nt.y);
            this.controls.update();

        } else {

            this.camera.position.z -= 10;
            this.camera.lookAt(this.camera.position.x, 0, this.camera.position.z);
            this.camera.updateProjectionMatrix();
            this.controls.target = new THREE.Vector3(this.camera.position.x, 0, this.camera.position.z)
            this.controls.update();
            console.log('panLeft', this.camera);
        }
    }
    panRight($event) {
        if (this.props.canvasView == "3d") {
            // this.controls.target = new THREE.Vector3(this.controls.target.x - 0.1, this.controls.target.y, this.controls.target.z - 0.1);
            var nt = new THREE.Vector2(this.controls.target.x, this.controls.target.z).rotateAround(new THREE.Vector2(this.camera.position.x, this.camera.position.z), +0.1);

            this.controls.target = new THREE.Vector3(nt.x, this.controls.target.y, nt.y);
            this.controls.update();

        } else {

            this.camera.position.z += 10;
            this.camera.lookAt(this.camera.position.x, 0, this.camera.position.z);
            this.camera.updateProjectionMatrix();
            this.controls.target = new THREE.Vector3(this.camera.position.x, 0, this.camera.position.z)
            this.controls.update();
            console.log('panRight', this.camera);
        }
    }

    orthoView(camerapos = null, camerazoom = null) {
        this.camera = new THREE.OrthographicCamera(window.innerWidth / - 2, window.innerWidth / 2, window.innerHeight / 2, window.innerHeight / - 2, 1, 1000);
        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        this.camera.up = new THREE.Vector3(this.camera.up.x, this.camera.up.y, this.camera.up.z)
            .applyMatrix4(new THREE.Matrix4().makeRotationZ(THREE.MathUtils.DEG2RAD * 45));
        // TODO: aus raummaße berechnen
        var bb = ThreeUtils.getRoomBB(this.props.walls);

        this.camera.position.x = -bb.depth / 2;// 0;// -200;
        this.camera.position.y = this.props.walls[0].h + 10;// ; // TODO: weiter öffnen, je nach größe des
        this.camera.position.z = -bb.width / 2;// 0;// bb.width; // -250;
        this.camera.rotation.z = Math.PI;
        this.camera.zoom = 0.3 + 500 / bb.largest; // 0.5;
        //this.camera.fov = 10; // bb.largest / 1.0;

        if (camerapos) {
            this.camera.position.x = camerapos.x;
            this.camera.position.z = camerapos.z;
        }
        if (camerazoom)
            this.camera.zoom = camerazoom;

        this.controls.enableDamping = false;
        this.controls.dampingFactor = 0.1;
        this.controls.enableRotate = false;
        this.controls.enableZoom = true;
        this.controls.zoomSpeed = 1;

        this.controls.enablePan = true;
        this.controls.panSpeed = 2;

        this.controls.keyPanSpeed = 2000;
        this.controls.maxZoom = bb.largest / 70; // 10;
        this.controls.minZoom = 0.3;

        this.controls.target = new THREE.Vector3(this.camera.position.x, 0, this.camera.position.z)
        this.camera.updateProjectionMatrix();
        this.controls.update();
        this.controls.mouseButtons =
        {

            LEFT: THREE.MOUSE.PAN,
            MIDDLE: THREE.MOUSE.DOLLY,
            RIGHT: null
        }

        // if (this.camera.fov < 45) this.camera.fov = 45;
        // if (this.camera.fov > 110) this.camera.fov = 110;
        //this.camera.updateProjectionMatrix();

        // spezifische Szenenobjekte ausblenden
        //      this.scene.background = new THREE.Color().setRGB(0.06, 0.06, 0.06);
        this.scene.traverse(x => {
            if (x.type == "Mesh" || x.type == "Group") {
                if (x?.userData?.type === "sockelleiste" || x?.userData?.type === "camera")
                    x.visible = false;

                if (x?.userData?.type === "wall") {
                    (x as THREE.Mesh).material = (x as THREE.Mesh).material = new THREE.MeshPhongMaterial({ color: 0xaaaaaa, specular: 0xaaaaaa, emissive: 0xaaaaaa, shininess: 0 });
                }
                if (x?.name === "floor") {
                    (x as THREE.Mesh).material = new THREE.MeshPhongMaterial({ color: 0x111111, specular: 0x000000, emissive: 0x000000, shininess: 0 });
                }
                // if (x?.name === "floor-extended") {
                //     (x as THREE.Mesh).material = new THREE.MeshBasicMaterial({ color: 0x020202, reflectivity: 0 });
                // }


            }
        });

        //  this.camera.lookAt(0, 20, -110);
        if (this.ceiling) this.ceiling.visible = false;
        console.log('orthoview')
    }
    innerView() {

        //        this.camera = new THREE.PerspectiveCamera(65, window.innerWidth / window.innerHeight, 1, 20000);
        this.camera = new THREE.PerspectiveCamera(65, (this.canvasTarget as any).innerWidth / (this.canvasTarget as any).innerHeight, 1, 20000);

        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        this.camera.position.x = 150;
        this.camera.position.y = 180;
        this.camera.position.z = 450;

        this.controls.enableDamping = false;
        this.controls.dampingFactor = 10;
        this.controls.enableRotate = false;
        this.controls.enablePan = false;
        this.controls.enableZoom = false;
        this.controls.zoomSpeed = 5;

        this.controls.panSpeed = 20;
        this.controls.keyPanSpeed = 26000;
        this.controls.minDistance = 0;
        this.controls.maxDistance = 1200;
        this.controls.target = new THREE.Vector3(this.camera.position.x + 0.5, this.camera.position.y - 0.1, this.camera.position.z - 1)
        this.controls.update();


        console.log('this.controls.target', this.controls.target);



        // spezifische Szenenobjekte einblenden
        //     this.scene.background = new THREE.Color().setRGB(0.8, 0.9, 1);

        this.scene.traverse(x => {
            if (x.type == "Mesh" || x.type == "Group") {
                if (x?.userData?.type === "sockelleiste" || x?.userData?.type === "camera")
                    x.visible = true;
                if (x?.userData?.type === "wall") {
                    (x as THREE.Mesh).material = this.wallmaterial;
                }
                if (x?.name === "floor") {
                    (x as THREE.Mesh).material = this.floormaterial;
                }
                if (x?.userData.type === "windowhelper") {
                    (x as THREE.Mesh).visible = false;
                }

            }
        });
        if (this.ceiling) this.ceiling.visible = true;
        console.log('innerView')
    }

    floor: THREE.Mesh; floormaterial = new THREE.MeshPhongMaterial();
    floorshape: any;
    async createFloor(walls) {
        try {
            this.scene.traverse(x => {
                if (x.userData?.type == "floor") this.scene.remove(x);
            });
        } catch (e) { }

        const shape = new THREE.Shape();
        this.floorshape = [];
        shape.autoClose = true;
        shape.moveTo(-walls[0].p1.z, walls[0].p1.x);
        this.floorshape.push([-walls[0].p1.z, walls[0].p1.x]);

        shape.moveTo(-walls[0].p2.z, walls[0].p2.x);
        this.floorshape.push([-walls[0].p2.z, walls[0].p2.x]);

        for (var j = 1; j < walls.length; j++) {
            shape.lineTo(-walls[j].p2.z, walls[j].p2.x);
            this.floorshape.push([-walls[j].p2.z, walls[j].p2.x]);
        }
        this.floorshape.splice(this.floorshape.length - 1);

        console.log('this.floorshape', this.floorshape);
        var extrudeSettings = {
            steps: 1, depth: 0.01, bevelEnabled: false//, material: 0, extrudeMaterial: 1
        };
        const loader = new THREE.TextureLoader();
        this.floormaterial = new THREE.MeshPhongMaterial({ color: 0x848484, transparent: false, opacity: 1, specular: 0x494949, emissive: 0x5b5b5b, shininess: 0 })

        const Texture = loader.load("assets/textures/she_konfigurator_fussboden_textur_RZ_small.jpg", texture => {
            this.floormaterial.map = texture;
            this.floormaterial.needsUpdate = true;
        });

        Texture.wrapS = Texture.wrapT = THREE.RepeatWrapping;
        Texture.repeat.set(0.0085, 0.008);
        // Texture.rotation = Math.PI / 2;
        const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
        ///        geometry.computeFaceNormals();
        const mesh = new THREE.Mesh(geometry, this.floormaterial);
        mesh.receiveShadow = true;
        mesh.castShadow = false;
        mesh.rotateX(-Math.PI / 2);
        mesh.updateMatrix();
        mesh.name = "floor";
        mesh.userData.isbuilding = true;
        mesh.userData.type = "floor";

        // (mesh as any).wallindex = i;
        this.meshes.push(mesh);
        // mesh.userData.wallindex = i;
        this.scene.add(mesh);

        this.floor = mesh;

        // extendedfloor
        var f = (this.baseScene as any).baseplane;
        f.userData.type = "floor";
        f.name = "floor-extended";
        this.meshes.push(f);
        console.log('floor baseplane', f)
    }

    createCeiling(walls) {
        try {
            this.scene.traverse(x => {
                if (x.userData?.type == "ceiling") this.scene.remove(x);
            });
        } catch (e) { }

        const shape = new THREE.Shape();
        shape.autoClose = true;
        shape.moveTo(-walls[0].p1.z, walls[0].p1.x);
        shape.moveTo(-walls[0].p2.z, walls[0].p2.x);
        for (var j = 1; j < walls.length; j++) {
            shape.lineTo(-walls[j].p1.z, walls[j].p1.x);
            shape.lineTo(-walls[j].p2.z, walls[j].p2.x);
        }
        var extrudeSettings = {
            steps: 1, depth: 0.01, bevelEnabled: false//, material: 0, extrudeMaterial: 1
        };
        const loader = new THREE.TextureLoader();
        const floor_material = new THREE.MeshPhongMaterial({ color: 0x848484, transparent: false, opacity: 1, specular: 0x494949, emissive: 0x5b5b5b, shininess: 0 })

        const Texture = loader.load("assets/textures/ceiling2.jpg", texture => {
            floor_material.map = texture;
            floor_material.needsUpdate = true;
        });

        Texture.wrapS = Texture.wrapT = THREE.RepeatWrapping;
        Texture.repeat.set(0.0085, 0.008);
        // Texture.rotation = Math.PI / 2;
        const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
        ///        geometry.computeFaceNormals();
        const mesh = new THREE.Mesh(geometry, floor_material);
        mesh.receiveShadow = true;
        mesh.castShadow = false;
        mesh.rotateX(-Math.PI / 2);
        mesh.translateZ(walls[0].h)
        mesh.updateMatrix();
        mesh.name = "ceiling";
        mesh.userData.isbuilding = true;
        mesh.userData.type = "ceiling";
        this.meshes.push(mesh);

        this.scene.add(mesh);
        this.ceiling = mesh;

    }



    cutWall(wallmesh, index) {
        // Cuts
        for (var i = 0; i < this.cutHelpers.length; i++) {
            if (wallmesh.userData.wallindex == this.cutHelpers[i].userData.wallindex) {
                this.renderer.render(this.scene, this.camera);
                var meshResult = this.cutMesh(wallmesh, this.cutHelpers[i]);
                if (meshResult) {
                    meshResult.name = wallmesh.name;
                    this.scene.remove(wallmesh)

                    this.meshes[index] = meshResult;
                    this.scene.add(meshResult);
                    wallmesh = meshResult;
                }
            }
        }
    }

    async createWall(wall, index, wallheight) {
        const shape = new THREE.Shape();
        shape.autoClose = true;
        shape.moveTo(-wall.p1.z, wall.p1.x);
        shape.lineTo(-wall.p2.z, wall.p2.x);
        shape.lineTo(-wall.p3.z, wall.p3.x);
        shape.lineTo(-wall.p4.z, wall.p4.x);
        var extrudeSettings = {
            steps: 1,
            depth: wallheight,// cs[0].y,
            bevelEnabled: false
        };

        const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);

        const mesh = new THREE.Mesh(geometry, this.wallmaterial);
        mesh.receiveShadow = true;
        mesh.castShadow = true;
        mesh.rotateX(-Math.PI / 2);
        mesh.updateMatrix();
        mesh.name = "wall_" + index;
        mesh.userData.isbuilding = true;
        mesh.userData.type = "wall";

        // if (this.props.walls.length === 3) {
        //     mesh.visible = false; // offener raum
        //     return;
        // }
        (mesh as any).wallindex = index;
        mesh.userData.wallindex = index;

        this.meshes.push(mesh);
        this.scene.add(mesh);
        if (this.props.walls[index].invisible)
            mesh.visible = false;

        this.renderer.render(this.scene, this.camera);

    }

    cutMesh(meshtocut, mesh) {
        mesh.updateMatrix();
        meshtocut.updateMatrix();
        const bspA = (CSG as any).fromMesh(mesh);
        const bspB = (CSG as any).fromMesh(meshtocut);
        const intersection = bspB.intersect(bspA) as any;
        if (intersection.polygons.length > 0) {
            //  console.log('intersection', intersection.polygons.length)
            const bspResult = bspB.subtract(bspA);
            const meshResult = (CSG as any).toMesh(bspResult, new THREE.Matrix4());
            meshResult.updateMatrix();

            //   mesh.visible = true;
            //   meshtocut.visible = false;
            meshResult.material = meshtocut.material;
            meshResult.receiveShadow = true;
            meshResult.castShadow = false;
            //    console.log('meshresult', meshResult)
            meshResult.userData = meshtocut.userData;

            return meshResult;
        }
        return null;
    }


    async createWalls(walls) {

        var toremove = [];
        if (this.scene)
            this.scene.traverse(x => {
                if (x.userData?.type == "wall" || x.userData?.type == "cuthelper") {
                    toremove.push(x);
                }
            });
        for (var i = 0; i < toremove.length; i++) {
            this.scene.remove(toremove[i]);
        }
        for (var i = 0; i < this.meshes.length; i++) {
            if (this.meshes[i].userData.type == "wall") {
                this.meshes.splice(i, 1);
                i--;
            }
        }


        if (walls.length === 3) {
            this.isopenRoom = true;
            // offener Raum => Hack 4.Wand mit Höhe 0
            var extrawall = {
                p1: { x: walls[2].p2.x, z: walls[2].p2.z },
                p2: { x: walls[0].p1.x, z: walls[0].p1.z },
                p3: { x: walls[0].p1.x, z: walls[0].p1.z - 0.1 },
                p4: { x: walls[2].p2.x, z: walls[2].p2.z - 0.1 },
                h: walls[0].h,
                invisible: true
            };
            walls.push(extrawall);
            //  await this.createWalls(walls);
        }
        else {
        }


        try {
            if (this.scene)
                this.scene.traverse(x => {
                    try {
                        if (x.userData?.type == "wall" || x.userData?.type == "sockelleiste") {

                            this.scene.remove(x);

                            for (var i = 0; i < this.meshes.length; i++) {
                                if (this.meshes[i].uuid === x.uuid) {
                                    this.meshes.splice(i, 1);
                                    break;
                                }
                            }
                        }
                    } catch (err) { }

                });
        } catch (err) { }
        var sockelmaterial = new THREE.MeshPhongMaterial({ color: 0x848484, transparent: false, opacity: 1, specular: 0x494949, emissive: 0x5b5b5b, shininess: 0 })

        //   wallmaterial.envMapIntensity = 1;
        const loader = new THREE.TextureLoader();
        const Texture = loader.load("assets/textures/ceiling2.jpg", texture => { this.wallmaterial.map = texture; this.wallmaterial.needsUpdate = true; });
        Texture.wrapS = Texture.wrapT = THREE.RepeatWrapping;
        Texture.repeat.set(0.01, 0.01);

        // WÃ¤nde
        for (var i = 0; i < walls.length; i++) {
            try {
                var wall = walls[i];
                await this.createWall(wall, i, wall.h);
            }
            catch (e) {
                console.error(e)
            }
        }

        // Sockelleisten
        for (var i = 0; i < walls.length; i++) {
            try {
                var wall = walls[i];
                if (wall.h < 1) continue;

                const shape = new THREE.Shape();
                shape.autoClose = true;
                shape.moveTo(-wall.p1.z, wall.p1.x);
                shape.lineTo(-wall.p2.z, wall.p2.x);

                var vzx32 = (wall.p3.x - wall.p2.x) / 2;
                var vzz32 = (wall.p3.z - wall.p2.z) / 2;

                var v21z = (-wall.p2.x + wall.p1.x)
                var v21x = (-wall.p2.z + wall.p1.z)
                var n = Utils.norm(v21x, v21z);
                var nr = Utils.rotatePointY(n[0], n[1], -Math.PI / 2);
                nr[0] *= 3; // Tiefe
                nr[1] *= 3;

                shape.lineTo(-wall.p2.z - nr[0], wall.p2.x + nr[1]);

                var vzx41 = (wall.p1.x - wall.p4.x) / 2;
                var vzz41 = (wall.p1.z - wall.p4.z) / 2;

                shape.lineTo(-wall.p1.z - nr[0], wall.p1.x + nr[1]);

                var extrudeSettings = {
                    steps: 1,
                    depth: 10,// cs[0].y,
                    bevelEnabled: false
                };

                const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
                ///                geometry.computeFaceNormals();

                const mesh = new THREE.Mesh(geometry, sockelmaterial);
                mesh.receiveShadow = true;
                mesh.castShadow = true;
                mesh.rotateX(-Math.PI / 2);
                mesh.updateMatrix();
                mesh.name = "sockel_" + i;
                mesh.userData.isbuilding = true;
                mesh.userData.type = "sockelleiste";
                mesh.userData.wallindex = i;
                this.meshes.push(mesh);
                this.scene.add(mesh);


                if (this.props.walls[i].invisible)
                    mesh.visible = false;


            }
            catch (e) {
                console.error(e)
            }
        }
    }

    componentWillUnmount() {
        console.log('componentWillUnmount');
        (this.canvasTarget as any).removeEventListener("pointermove", this.mousemoveCanvas.bind(this));
        (this.canvasTarget as any).removeEventListener('pointerdown', this.sceneMouseDown.bind(this));
        (this.canvasTarget as any).removeEventListener('pointerup', this.sceneMouseUp.bind(this));
        (this.canvasTarget as any).removeEventListener('pointerup', this.sceneMouseUp.bind(this));


        window.removeEventListener('resize', () => { this.resize() })
        this.renderer.dispose();
        this.scene = null;
        this.camera = null;
        this.controls = null;
        this.canvasTarget.removeChild(this.renderer.domElement);
        cancelAnimationFrame(this.animationRequestID);
        this.animationRequestID = undefined;
    }

    room: any; wallmaterial: THREE.MeshPhongMaterial;
    testwindow: any; isopenRoom = false;

    async createRoom() {
        this.wallmaterial = new THREE.MeshPhongMaterial({ color: 0x848484, transparent: false, opacity: 0.5, specular: 0x494949, emissive: 0x5b5b5b, shininess: 0 })

        var walls = this.props.walls;
        await this.createWalls(walls);
        this.createFloor(walls);
        this.createCeiling(walls);

        // cameras
        this.viewpoints = [];
        await this.createCameras(this.props.walls);

        // Licht
        this.createlights();

        this.plane.setFromCoplanarPoints(new THREE.Vector3(), new THREE.Vector3(1, 0, 0), new THREE.Vector3(0, 1, 0));
    }

    public createlights() {
        var w = this.props.walls;

        var insertpoint = Utils.calcRoomInsertPoint(w);
        var h = this.props.walls[0].h * 0.66;

        // helper
        // const geometry = new THREE.SphereGeometry(15, 32, 32);
        // const material = new THREE.MeshBasicMaterial({ color: 0xffff00 });
        // const sphere = new THREE.Mesh(geometry, material);
        // sphere.position.set(-insertpoint.z, h, -insertpoint.x);
        // this.scene.add(sphere);

        this.createLight('assets/models/lamps/scene.gltf', { x: -insertpoint.z, y: h, z: -insertpoint.x }, {}, 0.25, 0.21, 0.42, 0);
        //        this.createLight('assets/models/lamps/scene.gltf', { x: -250, y: 240, z: -300 }, { x: 250, y: 0, z: 100 }, {}, 0.25, 0.21, 0.42, 0);
    }


    createIcon(filename, position, rotation, scale) {
        const loader = new SVGLoader();

        loader.load(filename, (data) => {
            const paths = data.paths;
            const group = new THREE.Group();

            for (let i = 0; i < paths.length; i++) {
                const path = paths[i] as any;
                const material = new THREE.MeshPhongMaterial({
                    color: path.color,
                    side: THREE.DoubleSide,
                    depthWrite: false
                });
                const shapes = path.toShapes(true);
                for (let j = 0; j < shapes.length; j++) {
                    const shape = shapes[j];
                    const geometry = new THREE.ShapeGeometry(shape);
                    geometry.center();
                    const mesh = new THREE.Mesh(geometry, material);

                    group.add(mesh);
                }
            }



            group.position.set(position.x, position.y, position.z);
            //     group.scale.set(scale, scale, scale);
            if (rotation?.x) group.rotateX(rotation.x);
            if (rotation?.y) group.rotateY(rotation.y);
            if (rotation?.z) group.rotateZ(rotation.z);
            //     group.updateMatrix();

            console.log('svggroup', group)
            this.scene.add(group);
        },
            (error) => {
                console.log('An error happened');
            });

    }


    async createCameras(walls) {
        this.viewpoints = [];
        // TODO: positionen/Orientierung aus WÃ¤nde
        for (var i = 0; i < walls.length; i++) {

            var wall = walls[i];

            var v21z = (-wall.p2.x + wall.p1.x);
            var v21x = (-wall.p2.z + wall.p1.z);

            var n = Utils.norm(v21x, v21z);
            var nr = Utils.rotatePointY(n[0], n[1], -Math.PI / 2);
            var angle = -new Vector2(n[0], n[1]).angle();

            var xpos = - (-wall.p1.z - nr[0] * 25 + v21x / 2);
            var zpos = -(wall.p1.x + nr[1] * 25 - v21z / 2);
            var lookatz = -nr[1];
            var lookatx = -nr[0];

            // TODO: entfernen

            var vp = {
                position: {
                    x: -xpos, y: 0, z: zpos
                },
                userData: { lookatx: lookatx, lookatz: lookatz }
            };

            // deprecated, mit Männchen im Raum 
            // await this.createInterior( 'assets/newxamples/meannchen.gltf', 'camera', false, { x: xpos, y: 0, z: -zpos }, { y: angle }, 9, true, true, false, { angle: angle, nr: nr, lookatx: lookatx, lookatz: lookatz });
            // this.viewpoints.push(vp);

            this.viewpoints.push(vp);
        }


    }


    lastFurnitureIntersected: any;
    setCamera(viewpoint) {
        this.camera.position.y = 165;
        this.camera.position.x = viewpoint.position.x;
        this.camera.position.z = viewpoint.position.z;
        this.camera.up = new THREE.Vector3(0, 1, 0)
        var lookatx = this.camera.position.x + viewpoint.userData.lookatx;
        var lookatz = this.camera.position.z + viewpoint.userData.lookatz;
        if (this.controls) {

            this.controls.target = new THREE.Vector3(lookatx, this.camera.position.y, lookatz);
            this.camera.fov = 100;
            this.controls.update();

            console.log('set camera', viewpoint, this.controls.position, this.controls.target)
        }
        ///      this.controls.target = new THREE.Vector3(lookatx , this.camera.position.y, lookatz);
        //        camera.target.position.copy(camTarget);

        var cambb = new THREE.Box3(new THREE.Vector3(this.camera.position.x - 1, this.camera.position.y - 1, this.camera.position.z - 1), new THREE.Vector3(this.camera.position.x + 1, this.camera.position.y + 1, this.camera.position.z + 1));
        this.scene.traverse((child) => {
            if (child.userData.type == 'furniture') {
                var objbb = new THREE.Box3().setFromObject(child);
                var intersects = cambb.intersectsBox(objbb);
                if (intersects) {
                    (child as any).visible = false;

                }
                else {
                    (child as any).visible = true;
                }
            }
        });




    }


    gltfs = []; // movable List, beinhaltet filename
    async addGltf2Scene(filename: string, type: string, showhelper: boolean, position: any, rotation: any, scale: number = 1, castShadow = true, movable = false, collisioncheck = false, userdata: any = {}) {
        //   console.log('createInterior', filename, position, type)

        if (!filename.startsWith('http'))
            filename = this.SERVERURL + filename;

        var gltf = await (this.loader).loadAsync(filename);

        if (movable) {
            this.gltfs.push({ filename: filename, gltf: gltf });
        }
        var bbox = new THREE.Box3().setFromObject(gltf.scene);
        //     console.log('gltf', gltf)

        //  var gltf = Utils.cloneGltf(gltf2);
        gltf.scene.traverse((child) => {
            if ((child as any).isMesh) {
                (child as any).cursor = 'pointer';
                child.userData.type = "child_" + type;
                child.castShadow = castShadow;
                //   (child as any).geometry.center(); // center here
            }
            if (child.type == "Object3D") {

            }

            var node = child as any;
            // if (node.material && (node.material.isMeshStandardMaterial ||
            //     (node.material.isShaderMaterial && node.material.envMap !== undefined))) {
            //     if (!filename.includes('fenster')) {
            //         node.material.envMap = this.scene.environment;
            //         node.material.envMapIntensity = 0.4; // boombox seems too dark otherwise
            //         //    console.log(filename, 'node.material', node.material);
            //     }
            // }

            if ((child as any).isNode) {

            }
        });
        gltf.scene.position.set(-position.x, position.y, -position.z);
        gltf.scene.scale.set(scale, scale, scale);
        if (rotation?.x) gltf.scene.rotateX(rotation.x);
        if (rotation?.y) gltf.scene.rotateY(rotation.y);
        if (rotation?.z) gltf.scene.rotateZ(rotation.z);

        if (type !== "camera")
            this.scene.add(gltf.scene);

        var t = type;
        gltf.scene.userData = userdata;
        if (type.includes('window') || type.includes('door')) {
            t = type.split('#')[0];
            gltf.scene.userData.wallindex = parseInt(type.split('#')[1]);
        }
        gltf.scene.userData.type = t;
        gltf.scene.userData.filename = filename;
        (gltf.scene as any).userData.movable = movable;

        // TODO: nur elternelment
        if (movable)
            this.meshes.push(gltf.scene);

        if (collisioncheck) {
            var bbox = new THREE.Box3().setFromObject(gltf.scene);
            this.objectboxes.push(bbox);
        }

        if ((type == "window" || type == "door") && showhelper) {
            var box3 = ThreeUtils.getBBox(gltf.scene);
            const dimensions = new THREE.Vector3().subVectors(box3.max, box3.min);
            const boxGeo = new THREE.BoxBufferGeometry(dimensions.x, dimensions.y, dimensions.z);
            const matrix = new THREE.Matrix4().setPosition(dimensions.addVectors(box3.min, box3.max).multiplyScalar(0.5));
            boxGeo.applyMatrix4(matrix);
            let mesh = new THREE.Mesh(boxGeo, new THREE.MeshBasicMaterial({ color: 0xdd6600, transparent: false, opacity: 0.5 }));
            if (type == "window")
                mesh = new THREE.Mesh(boxGeo, new THREE.MeshBasicMaterial({ color: 0xffaa11, transparent: false, opacity: 0.5 }));
            if (filename.indexOf("terrassentuer") > -1)
                mesh = new THREE.Mesh(boxGeo, new THREE.MeshBasicMaterial({ color: 0xee9944, transparent: false, opacity: 0.5 }));


            mesh.renderOrder = 999;
            mesh.material.depthTest = false;
            mesh.material.depthWrite = false;
            mesh.userData.type = "windowhelper";
            mesh.visible = true;
            gltf.scene.add(mesh);
        }

        return gltf;
    }

    cutHelpers = [];
    cutHelper(mesh, rotate = true) {
        var heightmult = 1; // hack
        if (mesh.userData.type == "door")
            heightmult = 0;
        if (mesh.userData.type == "door" && mesh.userData.filename.includes('terrassentuer'))
            heightmult = 0.995;
        if (mesh.userData.type == "door" && !mesh.userData.filename.includes('terrassentuer'))
            return;
        const ggeo = new THREE.BoxBufferGeometry(mesh.userData.width * 0.95, mesh.userData.height * heightmult, mesh.userData.depth * 2.4);
        const gmesh = new THREE.Mesh(ggeo, new THREE.MeshBasicMaterial({ color: 0x00ff00, transparent: false, opacity: 0.6 }));
        gmesh.position.set(mesh.position.x, mesh.position.y, mesh.position.z);
        gmesh.rotation.y = mesh.rotation.y;
        gmesh.userData.wallindex = mesh.userData.wallindex;
        gmesh.userData.type = "cuthelper";
        gmesh.position.y = mesh.position.y + mesh.userData.height / 2;
        gmesh.visible = false;

        this.scene.add(gmesh);
        this.cutHelpers.push(gmesh);
    }


    pointlight: any;
    createLight(filename, position, rotation, scale, itensity = undefined, penumbra = 1, decay = 0.1) {
        // TODO: paramter auf Raumgröße anpassen
        this.pointlight = new THREE.PointLight(0xf7decf, 0.4, 0, 2);
        this.pointlight.castShadow = true;
        this.pointlight.shadow.radius = 8;
        // bringt nix   this.pointlight.shadow.blurSamples = 120;
        this.pointlight.shadow.camera.near = 1.5; // default
        this.pointlight.shadow.camera.far = 5500; // default
        this.pointlight.shadow.mapSize.width = 1024; this.pointlight.shadow.mapSize.height = 1024;
        this.pointlight.position.set(position.x, position.y, position.z);
        this.scene.add(this.pointlight);
    }


    mouseWheel(event) {
        this.camera.fov += event.deltaY / 48.0;
        if (this.camera.fov < 45) this.camera.fov = 45;
        if (this.camera.fov > 110) this.camera.fov = 110;

        this.camera.updateProjectionMatrix();
        localStorage.setItem('camerazoom', JSON.stringify(this.camera.zoom));
    }

    // Maus Interaktion
    hoverobj: any;
    sceneHover(e) {
        if (!this.dragging && !this.mousedown) {

            this.mouse.x = (e.layerX / this.canvasTarget.clientWidth) * 2 - 1;
            this.mouse.y = -(e.layerY / this.canvasTarget.clientHeight) * 2 + 1;
            this.raycaster.setFromCamera(this.mouse, this.camera);
            this.intersects = this.raycaster.intersectObjects(this.meshes, true);


            if (this.intersects.length === 0) {
                document.getElementById("canvas").style.cursor = "default";
                return;
            }
            var obj = this.intersects[0].object;

            // deprecated
            // if (!this.dragging && this.props.canvasView == "3d") {
            //     for (var i = 0; i < this.viewpoints.length; i++) {
            //         this.viewpoints[i].children[0].material = new THREE.MeshPhongMaterial({ color: 0xaaaaaa, transparent: false, opacity: 0.9 });
            //     }
            // }

            if (obj)
                if (this.props.canvasView == "3d" && (obj.userData.isbuilding || obj.userData.type == "window" || obj.userData.type == "door" || obj.userData.type == "windowhelper" || obj.parent.userData.type == "furniture")) {
                    document.getElementById("canvas").style.cursor = "default";
                    this.updateProductsHelper(null);
                    //          console.log(obj.userData.type)
                    return;
                }

            this.hoverobj = null;
            if (this.intersects.length > 0) {
                obj = this.intersects[0].object; // the object that was intersected
                //  if (this.props.canvasView === "2d") {
                for (var i = 0; i < this.intersects.length; i++) {
                    if (this.intersects[i].object)
                        if (!this.intersects[i].object?.userData?.isbuilding && this.intersects[i].object.visible == true) {
                            obj = this.intersects[i].object;
                            break;
                        }
                }

                //   console.log('this.intersects.length > 0', this.intersects)
                // element in Seilsystem?
                if (this.intersects.length == 3 || (this.intersects[1].object?.parent?.parent?.userData?.type == "element" && this.intersects.length == 4)) {
                    //                    obj = this.intersects[0].object;
                    //   console.log("0a", this.intersects[0].object);
                    //  console.log("1a", this.intersects[1].object);
                    if (this.intersects[1].object?.parent?.parent?.userData?.type == "element") {
                        obj = this.intersects[1].object.parent.parent;
                        this.hoverobj = obj;
                    } else if (this.intersects[0].object?.parent?.parent?.userData?.type == "element") {
                        obj = this.intersects[0].object.parent.parent;
                        this.hoverobj = obj;

                    }

                    //  console.log("2a", this.intersects[2].object);
                } else {

                    // je nach Anzeige Objekte waehlen
                    this.hoverobj = this.getObjectRoot(obj);
                }


                var cont = false;
                //  }
            }

            // hoverobj = this.getObjectRoot(obj);

            if (this.props.canvasView == "2d") {
                if (this.hoverobj)
                    if (this.hoverobj?.userData?.type === "lamp" && !this.props.selectableTypes?.includes("lamp"))
                        this.hoverobj = null;

                if (this.hoverobj)
                    if ((this.hoverobj?.userData?.type === "door" || this.hoverobj?.userData?.type === "window") && !this.props.selectableTypes?.includes("window"))
                        this.hoverobj = null;
                if (this.hoverobj) if (this.hoverobj?.userData?.type === "floor" || this.hoverobj?.userData?.type === "ceiling")
                    this.hoverobj = null;
                if (this.hoverobj) if (this.hoverobj.userData.type === "camera" && this.props.canvasView == "3d")
                    this.hoverobj = null;
                if (this.hoverobj) if (this.hoverobj.userData.type === "camera" && this.props.canvasView == "2d")
                    this.hoverobj = null;
                if (this.hoverobj) if (this.hoverobj.userData.type === "furniture" && !this.props.selectableTypes?.includes("furniture"))
                    this.hoverobj = null;


                if (!this.hoverobj) {
                    this.updateHoverHelper(null);
                    document.getElementById("canvas").style.cursor = "default";
                    return;
                }
                document.getElementById("canvas").style.cursor = "pointer";

            }

            // 3D
            if (!this.dragging && this.props.canvasView == "3d") {

                //  produktset
                if (this.props.canvasView == "3d" && (this.hoverobj?.userData?.type == "produkt" || this.hoverobj?.userData?.type == "element") && this.props.selectableTypes[0] === "product") {
                    console.log(obj.userData.type, this.hoverobj.userData.posOnRope)

                    var pid = this.hoverobj.userData.product.id;
                    document.getElementById("canvas").style.cursor = "pointer";
                    if (this.hoverobj.userData.posOnRope) {
                        this.updateProductsHelper(this.hoverobj.userData?.element.productid, this.hoverobj.userData?.elementindex);

                    }
                    else {
                        this.updateProductsHelper(pid, this.hoverobj.userData?.product?.elementindex);

                    }
                    return;
                }
                else {

                    if (this.hoverobj?.userData?.type == "ropesystem") {
                        console.log('ropsesystem hover')
                    }
                    else {
                        document.getElementById("canvas").style.cursor = "default";
                        this.updateProductsHelper(null)
                    }
                }

                if (this.hoverobj?.userData?.type === "camera")
                    this.hoverobj.children[0].material = new THREE.MeshPhongMaterial({ color: 0xFF6600, transparent: false, opacity: 0.7, specular: 0xFF6600, shininess: 0 });

                return;
            }

            document.getElementById("canvas").style.cursor = "pointer";
            this.updateHoverHelper(this.hoverobj);



        }


    }

    hoverobjectHelper = null;
    async updateHoverHelper(hoverobject) {
        //  console.log('updateHoverHelper1', hoverobject);
        if (this.hoverobjectHelper)
            this.scene.remove(this.hoverobjectHelper);
        if (!hoverobject)
            return;

        var bbox = await ThreeUtils.getBBox(hoverobject);
        bbox = bbox.expandByScalar(2);
        // console.log('updateHoverHelper', bbox);
        //      this.create3DMarker(bbox, 60, 10, 10);
        this.hoverobjectHelper = new THREE.Box3Helper(bbox, new THREE.Color(0xffffaa));
        this.hoverobjectHelper.geometry;
        (this.hoverobjectHelper.material as any).depthTest = false;
        (this.hoverobjectHelper.material as any).depthWrite = false;
        this.hoverobjectHelper.visible = true;
        this.hoverobjectHelper.renderOrder = 99999;

        this.scene.add(this.hoverobjectHelper);
    }



    updateSelectionBox() {
        // update view
        this.renderer.render(this.scene, this.camera);
        if (this.selectBoxHelper)
            this.scene.remove(this.selectBoxHelper);
        this.selectedobject = this.dragObject;

    }


    getNormalFromWall(wallindex) {
        var wall = this.props.walls[this.dragObject.userData.wallindex];
        var wx = wall.p1.x - wall.p2.x;
        var wz = wall.p1.z - wall.p2.z;
        var s = new THREE.Vector3(wx / 100.0, 0, wz / 100.0);
        this.pointOfIntersection.z = 0;
    }

    calcNearestWallPoint(wallindex) {
        var curpos = this.dragObject.position;
        // this.raycaster.setFromCamera(this.mouse, this.camera);
        this.intersects = this.raycaster.intersectObjects(this.meshes, true);
        if (this.intersects.length === 0) return;
        (this.raycaster as THREE.Raycaster).ray.intersectPlane(this.plane, this.pointOfIntersection);


    }

    isBetweenWalls(obj) {
        var floorbb = new THREE.Box3().setFromObject(this.floor);
        var objbb = new THREE.Box3().setFromObject(obj);
        objbb.min.y = -2;// nicht alle sind Objekte auf dem Boden
        var intersects = floorbb.intersectsBox(objbb);

        if (obj.position.y > this.props.walls[0].h)
            intersects = false;
        return intersects;
    }

    hitsOtherWall(dragObject = null) {


        if (dragObject?.userData?.isRopeSystem) {
            for (var i = 0; i < this.meshes.length; i++) {
                if ((this.meshes[i].userData.type == "wall")) {
                    this.meshes[i].updateMatrix();
                    const bspA = (CSG as any).fromMesh(this.meshes[i]);
                    var cl = this.dragObject.children.length - 1;
                    var box3 = ThreeUtils.getBBox(this.dragObject.children[cl]);
                    const dimensions = new THREE.Vector3().subVectors(box3.max, box3.min);
                    const boxGeo = new THREE.BoxBufferGeometry(dimensions.x, dimensions.y, dimensions.z);
                    const matrix = new THREE.Matrix4().setPosition(dimensions.addVectors(box3.min, box3.max).multiplyScalar(0.5));
                    boxGeo.applyMatrix4(matrix);
                    const mesh = new THREE.Mesh(boxGeo, new THREE.MeshBasicMaterial({ color: 0xffcc55, transparent: false, opacity: 0.5 }));
                    //  this.scene.add(mesh);
                    //                this.dragObject.children[cl].updateWorldMatrix(true);
                    mesh.updateMatrix()
                    const bspB = (CSG as any).fromMesh(mesh);


                    const intersection = bspB.intersect(bspA) as any;
                    //console.log('inter', i, ") ", dm, this.dragObject.position, intersection.polygons.length)

                    if (intersection.polygons.length > 0) {
                        // if (this.meshes[i].userData.type == "ceiling" || this.meshes[i].userData.type == "floor")
                        //     return -1;
                        if (this.meshes[i].userData.type == "wall") {
                            console.log('wallhit ', i)
                            return this.meshes[i].userData.wallindex;
                        }
                    }

                }
            }

            return -1;
        }

        // elementcheck?
        var wi = null;
        if (dragObject?.userData?.product?.elementindex != null)
            wi = dragObject.userData?.product.elements[dragObject.userData?.product.elementindex].mountingSurface.index;
        var elementindex = this.dragObject.userData?.product?.elementindex;
        var isCeilingFloor = false;
        if (elementindex != null)
            if (this.dragObject)
                if (this.dragObject.userData.product.elements[elementindex].mountingSurface.type == "ceiling" || this.dragObject.userData.product.elements[elementindex].mountingSurface.type == "floor")
                    isCeilingFloor = true;



        if (wi != null) {
            for (var i = 0; i < this.meshes.length; i++) {
                if ((this.meshes[i].userData.type == "wall" || this.meshes[i].userData.type == "ceiling" || this.meshes[i].userData.type == "floor") && (!(wi === this.meshes[i].userData.wallindex) || isCeilingFloor)) {
                    this.meshes[i].updateMatrix();
                    if (this.meshes[i].userData.type == "floor" && this.dragObject.userData.product.elements[elementindex].mountingSurface.type == "floor") continue;
                    const bspA = (CSG as any).fromMesh(this.meshes[i]);
                    var cl = this.dragObject.children.length - 1;
                    var box3 = ThreeUtils.getBBox(this.dragObject.children[cl]);
                    const dimensions = new THREE.Vector3().subVectors(box3.max, box3.min);
                    const boxGeo = new THREE.BoxBufferGeometry(dimensions.x, dimensions.y, dimensions.z);
                    const matrix = new THREE.Matrix4().setPosition(dimensions.addVectors(box3.min, box3.max).multiplyScalar(0.5));
                    boxGeo.applyMatrix4(matrix);
                    const mesh = new THREE.Mesh(boxGeo, new THREE.MeshBasicMaterial({ color: 0xffcc55, transparent: false, opacity: 0.5 }));
                    //  this.scene.add(mesh);
                    //                this.dragObject.children[cl].updateWorldMatrix(true);
                    mesh.updateMatrix()
                    const bspB = (CSG as any).fromMesh(mesh);

                    const intersection = bspB.intersect(bspA) as any;
                    //console.log('inter', i, ") ", dm, this.dragObject.position, intersection.polygons.length)

                    if (intersection.polygons.length > 0) {
                        if (this.meshes[i].userData.type == "ceiling" || this.meshes[i].userData.type == "floor")
                            return 999;
                        return this.meshes[i].userData.wallindex;
                    }

                }
            }
        }
        else {

            for (var i = 0; i < this.meshes.length; i++) {
                if ((this.meshes[i].userData.type == "wall" || this.meshes[i].userData.type == "ceiling" || this.meshes[i].userData.type == "floor") && (!(this.meshes[i].userData.wallindex === this.dragObject.userData.wallindex) || isCeilingFloor)) {
                    this.meshes[i].updateMatrix();
                    const bspA = (CSG as any).fromMesh(this.meshes[i]);
                    var cl = this.dragObject.children.length - 1;

                    var dm = this.dragObject.children[cl].clone();
                    dm.position.set(this.dragObject.position.x, this.dragObject.position.y, this.dragObject.position.z);
                    dm.rotation.set(this.dragObject.rotation.x, this.dragObject.rotation.y, this.dragObject.rotation.z);
                    dm.updateMatrix();
                    var bbox = new THREE.Box3().setFromObject(dm);

                    //    console.log('bbox', Math.abs(bbox.max.x - bbox.min.x), Math.abs(bbox.max.y - bbox.min.y), Math.abs(bbox.max.z - bbox.min.z))
                    //                this.dragObject.children[cl].updateWorldMatrix(true);
                    const bspB = (CSG as any).fromMesh(dm);

                    const intersection = bspB.intersect(bspA) as any;
                    //  console.log('inter', i, ") ", dm, this.dragObject.position, intersection.polygons.length)

                    if (intersection?.polygons?.length > 0) {
                        console.log('intersection', i, this.meshes[i].userData.type);
                        // if (this.dragObject.userData.wallindex == i)
                        //     continue;
                        if (this.dragObject.userData?.type == "window" || this.dragObject.userData?.type == "door")
                            if (this.meshes[i].userData.type == "wall") {
                                console.log('hitswall', this.meshes[i].userData)
                                if (this.props.walls.length === 3 && this.meshes[i].userData.wallindex == 3) {// offener Raum
                                    if (this.dragObject.userData.wallindex == 0)
                                        return 2;
                                    if (this.dragObject.userData.wallindex == 2)
                                        return 0;

                                }
                                return this.meshes[i].userData.wallindex;
                            }
                        // if (this.meshes[i].userData.type == "ceiling" || this.meshes[i].userData.type == "floor") {
                        //     console.log('ceilingfloorhit ', i)
                        //     continue;
                        // }
                        // return i;

                    }

                    // gegeüberliegende Wand? check mausposition
                    this.raycaster.setFromCamera(this.mouse, this.camera);
                    var mouseintersects = this.raycaster.intersectObjects(this.meshes, true);
                    if (mouseintersects.length > 0) {
                        for (var w = 0; w < mouseintersects.length; w++) {
                            if (mouseintersects[w].object.userData.type == "wall") {
                                if (this.dragObject.userData.wallindex != mouseintersects[w].object.userData.wallindex) {
                                    console.log('mouseintersects', mouseintersects[w].object.userData.wallindex)
                                    this.dragObject.userData.wallindex
                                    return mouseintersects[w].object.userData.wallindex;
                                }
                            }
                        }
                    }


                }
            }

        }
        return -1;

    }


    findFreeWallPosition(object) {
        // var wi = null;
        // if (object?.userData?.product?.elementindex != null)
        //     wi = object.userData?.product.elements[object.userData?.product.elementindex].mountingSurface.index;
        // var elementindex = object.userData.product?.elementindex;
        // var isCeilingFloor = false;
        // if (elementindex != null)
        //     if (object.userData.product.elements[elementindex].mountingSurface.type == "ceiling" || object.userData.product.elements[elementindex].mountingSurface.type == "floor")
        //         isCeilingFloor = true;

        var wallindex = object.userData.wallindex;
        var dir = 0;
        var collision = true;
        var wallhit = false;
        var ox = object.position.x;
        var oz = object.position.z;


        while (collision) {
            collision = false;
            wallhit = false;
            this.scene.traverse(x => {
                if (x.userData && !wallhit && !collision) {
                    if ((x.userData?.type == "window" || x.userData?.type == "door" || x.userData?.type == "wall") && object.uuid != x.uuid) {
                        if (this.checkCollision(x, object)) {
                            //   console.log('intersects!', x.userData.type);
                            if (x.userData?.type == "window" || x.userData?.type == "door") {
                                collision = true;
                            }
                            if (x.userData.type == "wall" && x.userData.wallindex != wallindex) {
                                wallhit = true;
                                collision = true;
                                dir++;
                                var insertpoint = Utils.calcWallInsertPoint(this.props.walls, this.selectedobject, true, this.props.interiors, dir);
                                this.selectedobject.position.set(insertpoint.x, this.selectedobject.position.y, insertpoint.z);
                                this.selectedobject.rotation.y = insertpoint.rot;
                                this.selectedobject.userData.wallindex = insertpoint.wall;
                                console.log('finfreewall', this.selectedobject)


                                return;
                            }
                        }
                    }

                }
            })
            if (dir == 0 || dir == 1 && collision && !wallhit) {
                var wall = this.props.walls[wallindex];
                var wx = wall.p1.x - wall.p2.x;
                var wz = wall.p1.z - wall.p2.z;
                console.log('move window ', dir, wx, wz)
                if (dir == 0) {
                    object.position.x += wz / 10;

                    object.position.z += wx / 10;
                }
                if (dir == 1) {
                    object.position.x -= wz / 10;

                    object.position.z -= wx / 10;
                }

            }
            if (dir == 2) {
                // no free position found
                object.position.x = ox;
                object.position.z = oz;
                break;
            }


            // if (dir == this.props.walls.length && collision) {
            //     // no free position found
            //     var insertpoint = Utils.calcWallInsertPoint(this.props.walls, this.selectedobject, true, this.props.interiors, 0);
            //     this.selectedobject.position.set(insertpoint.x, this.selectedobject.position.y, insertpoint.z);
            //     this.selectedobject.rotation.y = insertpoint.rot;
            //     this.selectedobject.userData.wallindex = 0; // insertpoint.wall;
            //     break;
            // }
        }
        this.props.setInteriorPosition(-this.selectedobject.position.x, this.selectedobject.position.y, -this.selectedobject.position.z, this.selectedobject.userData.wallindex);

    }

    findFreeRoomPosition(furniture, wallindex = 0) {
        var dir = 0;
        var collision = true;
        var wallhit = false;
        var ox = furniture.position.x;
        var oz = furniture.position.z;
        if (furniture.userData.type == "furniture") {
            while (collision) {

                collision = false;
                wallhit = false;
                this.scene.traverse(x => {
                    if (x.userData && !wallhit) {
                        if ((x.userData?.type == "furniture" || x.userData?.type == "wall") && furniture.uuid != x.uuid) {
                            if (this.checkCollision(x, furniture)) {

                                if (x.userData.type == "furniture")
                                    collision = true;
                                if (x.userData.type == "wall") {
                                    wallhit = true;
                                    collision = true;
                                    furniture.position.x = ox;
                                    furniture.position.z = oz;
                                    dir++;
                                }
                                //         return;
                            }
                        }

                    }
                })
                if (dir == 0)
                    furniture.position.x += 10;
                if (dir == 1)
                    furniture.position.z += 10;
                if (dir == 2)
                    furniture.position.x -= 10;
                if (dir == 3)
                    furniture.position.z -= 10;
                if (dir == 4) {
                    // no free position found
                    furniture.position.x = ox + 1;
                    furniture.position.z = oz + 1;
                    break;
                }
            }
        }
        if (furniture.userData.type == "lamp") {
            while (collision) {
                collision = false;
                wallhit = false;
                this.scene.traverse(x => {
                    if (x.userData && !wallhit) {
                        if ((x.userData?.type == "lamp" || x.userData?.type == "wall") && furniture.uuid != x.uuid) {
                            if (this.checkCollision(x, furniture)) {
                                // console.log('intersects!', x.userData.type);
                                if (x.userData.type == "lamp")
                                    collision = true;
                                if (x.userData.type == "wall") {
                                    wallhit = true;
                                    collision = true;
                                    furniture.position.x = ox;
                                    furniture.position.z = oz;
                                    dir++;
                                }
                                //         return;
                            }
                        }

                    }
                })
                if (dir == 0)
                    furniture.position.x += 5;
                if (dir == 1)
                    furniture.position.z += 5;
                if (dir == 2)
                    furniture.position.x -= 5;
                if (dir == 3)
                    furniture.position.z -= 5;
                if (dir == 4) {
                    // no free position found
                    furniture.position.x = ox + 1;
                    furniture.position.z = oz + 1;
                    break;
                }
            }

        }
        // fenster/tür auf wand finden
        if (furniture.userData.type == "window" || furniture.userData.type == "door") {
            var collcount = 0;
            while (collision && collcount < 500) {
                collision = false; collcount++;
                wallhit = false;
                this.scene.traverse(x => {
                    if (x.userData && !wallhit && !collision) {
                        if ((x.userData?.type == "window" || x.userData?.type == "door" || x.userData?.type == "wall") && furniture.uuid != x.uuid) {
                            if (this.checkCollision(x, furniture)) {
                                console.log('intersects!', x.userData.type);
                                if (x.userData?.type == "window" || x.userData?.type == "door") {
                                    collision = true;

                                }
                                if (x.userData.type == "wall" && x.userData.wallindex != dir) {
                                    console.log('wallhit', x.userData.wallindex, dir)
                                    wallhit = true;
                                    collision = true;
                                    dir++;

                                    // furniture.position.x = ox;
                                    // furniture.position.z = oz;
                                    // TODO: fenster drehen
                                    var insertpoint = Utils.calcWallInsertPoint(this.props.walls, this.selectedobject, true, this.props.interiors, dir);
                                    this.selectedobject.position.set(insertpoint.x, this.selectedobject.position.y, insertpoint.z);
                                    this.selectedobject.rotation.y = insertpoint.rot;
                                    this.selectedobject.userData.wallindex = insertpoint.wall;
                                    console.log('insertpoint', insertpoint);
                                }
                                //         return;
                            }
                        }

                    }
                })
                if (dir < this.props.walls.length && collision && !wallhit) {
                    var wall = this.props.walls[dir];
                    var wx = wall.p1.x - wall.p2.x;
                    var wz = wall.p1.z - wall.p2.z;
                    furniture.position.x += wz / 10;
                    furniture.position.z += wx / 10;
                    console.log('move window ', dir, wx, wz, furniture.position.x, furniture.position.z);

                }

                if (dir == this.props.walls.length && collision) {
                    // no free position found
                    var insertpoint = Utils.calcWallInsertPoint(this.props.walls, this.selectedobject, true, this.props.interiors, 0);
                    this.selectedobject.position.set(insertpoint.x, this.selectedobject.position.y, insertpoint.z);
                    this.selectedobject.rotation.y = insertpoint.rot;
                    this.selectedobject.userData.wallindex = 0; // insertpoint.wall;
                    break;
                }
            }
            this.props.setInteriorPosition(-this.selectedobject.position.x, this.selectedobject.position.y, -this.selectedobject.position.z, this.selectedobject.userData.wallindex);
            //this.selectedobject.userData.wallindex = dir;
            // this.selectedobject.updateMatrix();

        }

    }

    checkCollision(object1, object2): boolean {
        // vgl  https://github.com/mozdevs/gamedev-js-3d-aabb/blob/master/js/api_box.js
        //        this.dragObject.geometry.computeBoundingBox(); // gltf scene/group hat keine boundingbox, sondern meshes
        // var bbox = new THREE.Box3().setFromObject(this.dragObject);

        // var intersects = false;
        // // einfacher, check, ob objekt in Bodenpolygon
        // var intersects1 = Utils.inside([bbox.min.x, -bbox.min.z], this.floorshape);
        // var intersects2 = Utils.inside([bbox.max.x, -bbox.max.z], this.floorshape);
        // intersects = intersects1 && intersects2;
        // return !intersects; // intersection mit wand, wenn ein punkt nicht im Bodenpolygon

        // object1.updateMatrix();
        // object2.updateMatrix();
        // const bspA = (CSG as any).fromMesh(object1);
        // const bspB = (CSG as any).fromMesh(object2);
        // const intersection = bspA.intersect(bspB) as any;
        // if (intersection.polygons.length > 0)
        //     return true;

        var firstBB = new THREE.Box3().setFromObject(object1);

        var secondBB = new THREE.Box3().setFromObject(object2);

        var collision = firstBB.isIntersectionBox(secondBB);

        return collision;

    }

    getWall(obj) {
        var w = -1;
        for (var i = 0; i < this.meshes.length; i++) {
            if (this.meshes[i].userData.type == "wall") {
                console.log('getwall', i)
                this.meshes[i].updateMatrix();
                const bspA = (CSG as any).fromMesh(this.meshes[i]);
                var cl = obj.children.length - 1;
                var dm = obj.children[cl].clone();
                dm.position.set(obj.position.x, obj.position.y, obj.position.z);
                dm.rotation.set(obj.rotation.x, obj.rotation.y, obj.rotation.z);
                dm.updateMatrix();
                const bspB = (CSG as any).fromMesh(dm);
                const intersection = bspA.intersect(bspB) as any;
                console.log('inter', intersection.polygons.length)
                // if (intersection.polygons.length > 0) {
                //     return i;
                // }

            }
        }
        return w;
    }

    wallpointstoarray(wall) {
        var p = [];
        p.push([-wall.p1.z, wall.p1.x]);
        p.push([-wall.p2.z, wall.p2.x]);
        p.push([-wall.p3.z, wall.p3.x]);
        p.push([-wall.p4.z, wall.p4.x]);
        return p;
    }




    intersects;
    dragging = false;
    dragObject;
    pointOfIntersection = new THREE.Vector3();
    plane = new THREE.Plane();
    planeNormal = new THREE.Vector3(0, 0, 1);
    shift = new THREE.Vector3();
    mousedown = false;
    moved = false;
    mousedrag = false;
    // raycaster = new THREE.Raycaster();
    lastMousedownpos = new THREE.Vector3();

    sceneMouseDown(e) {
        console.log("scene down ", this.props, e, this.meshes)
        this.mousedown = true;
        this.mouse.x = (e.layerX / this.canvasTarget.clientWidth) * 2 - 1;
        this.mouse.y = -(e.layerY / this.canvasTarget.clientHeight) * 2 + 1;
        this.raycaster.setFromCamera(this.mouse, this.camera);

        this.intersects = this.raycaster.intersectObjects(this.meshes, true);
        var productintersects = this.raycaster.intersectObjects(this.productmeshes, true);
        console.log('productintersects', productintersects);

        var obj = null;
        var obj2 = null;
        var isRopeSystem = false;
        var isRopeElement = false;
        if (this.intersects.length > 0) {
            obj = this.intersects[0].object;
            if (this.intersects.length > 0)
                obj2 = this.intersects[1].object;


            // element in Seilsystem?
            // if (this.intersects.length == 3 || (this.intersects[1].object?.parent?.parent?.userData?.type == "element" && this.intersects.length == 4)) {
            //     if (this.intersects[1].object?.parent?.parent?.userData?.type == "element") {
            //         obj = this.intersects[1].object.parent.parent;
            //         this.hoverobj = obj;
            //     } else if (this.intersects[0].object?.parent?.parent?.userData?.type == "element") {
            //         obj = this.intersects[0].object.parent.parent;
            //         this.hoverobj = obj;

            //     }
            // } 


            if (obj?.parent?.userData?.isRopeSystem) {
                isRopeSystem = true;
                var intg = this.raycaster.intersectObjects(obj.parent.children, true);
                var o = intg[0]?.object;
                if (intg.length > 1) {
                    if (intg[1].object?.parent?.parent?.userData.type === "element")
                        isRopeElement = true;
                    this.dragObject = intg[1].object?.parent?.parent;
                }
            }
            if (obj?.parent?.parent?.userData.posOnRope) {
                isRopeElement = true;
                this.dragObject = obj?.parent?.parent;
            }


        }

        if ((obj?.userData?.isbuilding || obj?.userData?.type == "window" || obj?.userData?.type == "door" || obj?.userData?.type == "windowhelper" || obj?.parent?.userData?.type == "furniture" || obj?.parent?.userData?.type == "lamp") && this.props.canvasView != "2d") {

            // object auf Tür/fenster?
            if (obj2?.parent?.userData.type != "produkt") {
                this.updateProductsHelper(null);
                this.setSelectedObject(null, 0xFF6600);

                return;
            }
            else {
                obj = obj2;
            }
        }

        // Seilelement
        if (isRopeElement) {

            this.plane.setFromNormalAndCoplanarPoint(new THREE.Vector3(0, 1, 0), this.intersects[0].point); // normale der Wand
            this.moved = false;
            this.controls.enableRotate = false;

            this.dragging = true;
            if (!this.lastdownpos) {
                this.lastdownpos = new THREE.Vector3();
            }

            this.raycaster.setFromCamera(this.mouse, this.camera);
            (this.raycaster as THREE.Raycaster).ray.intersectPlane(this.plane, this.pointOfIntersection);

            this.selectedobject = this.dragObject;
            this.setSelectedObject(this.selectedobject, 0x006600);

            this.lastdownpos.copy(this.pointOfIntersection);
            this.lastMousedownpos.copy(this.lastdownpos);
            console.log('isRopeElement', obj);
            return;
        }
        // sonstige objekte
        if (this.intersects.length > 0) {
            //  obj = this.intersects[0].object; // the object that was intersected
            if (this.selectBoxHelper)
                this.scene.remove(this.selectBoxHelper);

            if (this.props.canvasView === "2d") {
                for (var i = 0; i < this.intersects.length; i++) {
                    if (!this.intersects[i].object.userData.isbuilding) {
                        obj = this.intersects[i].object;
                        break;
                    }
                }
                // je nach Anzeige Objekte waehlen
                this.selectedobject = this.getObjectRoot(obj);

                var cont = false;
                //        console.log('this.selectedobject', this.selectedobject)
                if ((this.selectedobject.userData.type === "window" || this.selectedobject.userData.type === "door") && JSON.stringify(this.props.selectableTypes) === JSON.stringify(["door", "window"])) cont = true;
                if (this.props.selectableTypes) {
                    if (this.selectedobject.userData.type === "furniture" && this.props.selectableTypes[0] === "furniture") cont = true;
                    if (this.selectedobject.userData.type === "lamp" && this.props.selectableTypes[0] === "lamp") cont = true;
                }
                if (!cont) {
                    this.dragObject = null;
                    this.selectedobject = null;
                    if (this.props?.setSelectedInteriorId)
                        this.props?.setSelectedInteriorId(null);
                    return; // falscher objekttyp ==> abbrechen
                }
                console.log('setselectedinteriorid', this.selectedobject.userData)
                this.props.setSelectedInteriorId(this.selectedobject.userData.interior.id);

                this.setSelectedObject(this.selectedobject, 0xFF6600);
            }

            console.log('obj', obj)
        }


        this.dragObject = this.getObjectRoot(obj);
        console.log('dragobject', this.dragObject);

        // Kamera
        if (this.props.canvasView == "3d" && this.dragObject.userData.type == "camera") {
            this.setCamera(this.dragObject);
            return;
        }

        if (this.props.canvasView == "3d" && this.dragObject.userData.type === "floorobject")
            this.dragObject = null;

        // kein objekt
        if (this.dragObject == null || this.dragObject.userData.type === "ceiling" || this.dragObject.userData.type === "floor") {
            this.dragObject = null;
            this.dragging = false;
            if (this.props.canvasView === "3d")
                this.controls.enableRotate = true;
            return;

        }

        if (this.props.canvasView == "2d") {
            this.plane.setFromNormalAndCoplanarPoint(this.planeNormal, this.intersects[0].point); // normale der Wand
            this.plane.setFromNormalAndCoplanarPoint(new THREE.Vector3(0, 1, 0), this.intersects[0].point);

            if (this.selectedobject.userData.type === "window" || this.selectedobject.userData.type === "door") {
                var wallindex = this.dragObject.userData.wallindex;
                console.log('wallindex', wallindex);
                var wall = this.props.walls[wallindex];
                var p1 = new THREE.Vector2(-wall.p1.z, -wall.p1.x);
                var p2 = new THREE.Vector2(-wall.p2.z, -wall.p2.x);
                var p = new THREE.Vector2(this.intersects[0].point.x, this.intersects[0].point.z);
                p = Utils.mousewallprojection(p, p1, p2);
                var p3d = new THREE.Vector3(p.x, 150, p.y);
                this.shift.subVectors(this.dragObject.position, p3d);
            }
            else {
                this.shift.subVectors(this.dragObject.position, this.intersects[0].point);
            }

            if (!this.lastdownpos)
                this.lastdownpos = new THREE.Vector3();
            this.lastdownpos.copy(this.selectedobject.position);
            this.lastMousedownpos.copy(this.lastdownpos);

            this.dragging = true;
        }
        else {
            // 3D-Ansicht: Elemente verschieben
            //  produktset
            if (this.props.canvasView == "3d" && this.dragObject.userData.type == "produkt" && this.props.selectableTypes[0] === "product") {
                var elementindex = this.dragObject.userData.product.elementindex;
                var isCeiling = false; var isFloor = false;
                if (elementindex)
                    if (this.dragObject?.userData?.product?.elements[elementindex]?.mountingSurface?.type == "ceiling")
                        isCeiling = true;
                    else
                        if (this.dragObject?.userData?.product?.elements[elementindex]?.mountingSurface?.type == "floor")
                            isFloor = true;


                this.scene.updateMatrixWorld();
                this.dragObject.updateWorldMatrix();
                this.dragObject.updateMatrixWorld();


                if (isCeiling || this.dragObject.userData.isRopeSystem || this.dragObject.userData.mountingSurface == 'ceiling' || this.dragObject.userData.mountingSurface == 'floor') {
                    this.plane.setFromNormalAndCoplanarPoint(new THREE.Vector3(0, 1, 0), this.intersects[0].point); // normale der Wand
                }
                else {
                    var wallindex = this.dragObject.userData.product.elements[elementindex].mountingSurface.index;
                    var dragwall = this.props.walls[wallindex];
                    var wallnormal = Utils.wallnormal(dragwall);
                    this.planeNormal = new THREE.Vector3(wallnormal[0], 0, wallnormal[1]);
                    this.plane.setFromNormalAndCoplanarPoint(this.planeNormal, this.intersects[0].point); // normale der Wand
                }

                if (isFloor) {
                    this.plane.setFromNormalAndCoplanarPoint(new THREE.Vector3(0, 1, 0), this.intersects[0].point); // normale der Wand

                }

                this.controls.enableRotate = false;
                this.moved = false;
                this.dragging = true;
                this.shift.subVectors(this.dragObject.position, this.intersects[0].point);
                if (!this.lastdownpos)
                    this.lastdownpos = new THREE.Vector3();
                this.selectedobject = this.getObjectRoot(obj);
                this.setSelectedObject(this.selectedobject, 0x006600);
                this.lastdownpos.copy(this.selectedobject.position);
                this.lastMousedownpos.copy(this.lastdownpos);

            }
            else {
                this.updateProductsHelper(null)
            }

        }




    }

    moveElement(event) {


        this.mouse.x = (event.offsetX / this.canvasTarget.clientWidth) * 2 - 1;
        this.mouse.y = - (event.offsetY / this.canvasTarget.clientHeight) * 2 + 1;

        // var rotp = Utils.rotatePointY(this.mouse.x, this.mouse.y, this.dragObject.userData.rot);
        // this.mouse.x = rotp[1]
        // this.mouse.y = rotp[0]

        this.raycaster.setFromCamera(this.mouse, this.camera);
        var poi = this.pointOfIntersection.clone().applyAxisAngle(new THREE.Vector3(0, 1, 0), 0);// this.dragObject.userData.rot);
        (this.raycaster as THREE.Raycaster).ray.intersectPlane(this.plane, poi);


        var dragVector1 = this.lastdownpos.clone().sub(poi);
        var dragVector = dragVector1.clone().applyAxisAngle(new THREE.Vector3(0, 1, 0), 0); //this.dragObject.userData.rot);

        var elementuserdata = this.dragObject.userData;
        // elementuserdata.startpos.x = -156
        // elementuserdata.endpos.x = 156
        var p1 = new Vector2(elementuserdata.startpos.x, elementuserdata.startpos.z);
        var p2 = new Vector2(elementuserdata.endpos.x, elementuserdata.endpos.z);

        var rotp = Utils.rotatePointY(p1.x - p2.x, p1.y - p2.y, this.dragObject.userData.rot);
        var rv = new THREE.Vector3(rotp[0], 0, rotp[1]);
        //        var rv = new THREE.Vector3(p1.x - p2.x, 0, p1.y - p2.y);

        var pro1 = dragVector.clone().projectOnVector(rv);
        var pro = pro1.clone().applyAxisAngle(new THREE.Vector3(0, 1, 0), -this.dragObject.userData.rot);

        var proabs = pro.length();
        var newposonrope = this.dragObject.userData.posOnRope + proabs;


        // between?
        var newpos = this.dragObject.position.clone().sub(pro);
        var l = elementuserdata.elementlength + 32;

        var startpos = (new THREE.Vector3(-elementuserdata.startpos.x, -elementuserdata.startpos.y, -elementuserdata.startpos.z));
        var endpos = (new THREE.Vector3(-elementuserdata.endpos.x, -elementuserdata.endpos.y, -elementuserdata.endpos.z));
        var halfelement = startpos.clone().sub(endpos).normalize();
        halfelement = halfelement.multiplyScalar(l / 2);
        var startpos2 = (new THREE.Vector3(-elementuserdata.startpos.x, -elementuserdata.startpos.y, -elementuserdata.startpos.z)).sub(halfelement);
        var endpos2 = (new THREE.Vector3(-elementuserdata.endpos.x, -elementuserdata.endpos.y, -elementuserdata.endpos.z)).add(halfelement);;


        const a = startpos2.distanceTo(newpos);
        const b = endpos2.distanceTo(newpos);
        const dgesamt = startpos2.distanceTo(endpos2);
        var between = false;
        var le = Math.abs(a + b - dgesamt)
        console.log('newposonrope' + newposonrope, ' le ' + le, 'a ' + a, 'b ' + b, 'dgesamt ' + dgesamt, 'halfelement ' + halfelement.x, 'l ' + l, 'elementlength ' + elementuserdata.elementlength)
        if (le < 1)
            between = true;
        if (this.dragObject.userData.isUno && le < elementuserdata.elementwidth) // warum auch immer?!,hack!!!
            between = true;
        if (between) {
            //     console.log(newposonrope);
            this.dragObject.userData.posOnRope = newposonrope;
            this.dragObject.position.sub(pro);
            this.lastdownpos.copy(poi);






            //      this.props.updateProducts(this.props.products);
        }


    }

    async moveW2WSystem(event) {
        this.mouse.x = (event.offsetX / this.canvasTarget.clientWidth) * 2 - 1;
        this.mouse.y = - (event.offsetY / this.canvasTarget.clientHeight) * 2 + 1;
        this.raycaster.setFromCamera(this.mouse, this.camera);
        var poi = this.pointOfIntersection.clone().applyAxisAngle(new THREE.Vector3(0, 1, 0), 0);// this.dragObject.userData.rot);
        (this.raycaster as THREE.Raycaster).ray.intersectPlane(this.plane, poi);


        var dragVector1 = this.lastdownpos.clone().sub(poi);
        var dragVector = dragVector1.clone().applyAxisAngle(new THREE.Vector3(0, 1, 0), 0); //this.dragObject.userData.rot);

        var elementuserdata = this.dragObject.userData;
        var p1 = new Vector2(elementuserdata.startpos.x, elementuserdata.startpos.z);
        var p2 = new Vector2(elementuserdata.endpos.x, elementuserdata.endpos.z);

        var rotp = Utils.rotatePointY(p1.x - p2.x, p1.y - p2.y, this.dragObject.userData.rot + 90 * Math.PI / 180);
        var rv = new THREE.Vector3(rotp[0], 0, rotp[1]);

        var pro1 = dragVector.clone().projectOnVector(rv);
        var pro = pro1.clone().applyAxisAngle(new THREE.Vector3(0, 1, 0), 0);// -this.dragObject.userData.rot);

        this.dragObject.position.sub(pro);
        this.lastdownpos.copy(poi);
        // TODO:
        this.resetobject = false;
        var wallhit = this.hitsOtherWall(this.dragObject);
        if (wallhit > -1) {

            for (var i = 0; i < this.props.products.length; i++) {
                if (this.props.products[i].id == this.dragObject.userData.product.id) {

                    await this.setSelectedObject(this.selectedobject, 0xFF0000);

                    if (this.dragObject.userData.isRopeSystem) {
                        this.resetobject = true;

                        break;
                    }

                    if (wallhit == 999) { // ceiling/floor hit
                        this.resetobject = true;
                        break;
                    }
                    var elementindex = this.dragObject.userData.product.elementindex;
                    var de = this.props.products[i].elements[elementindex];
                    if (de.mountingSurface.type == "ceiling" || de.mountingSurface.type == "floor") {
                        this.resetobject = true;
                        break;
                    }
                    else {
                        var from = de.mountingSurface.index;
                        var to = wallhit;
                        if (from != to)
                            console.log('wall hit (from,to):', from, to)
                        de.mountingSurface.index = wallhit;
                        //        if (!this.walldialogVisible)
                        //            this.props.updateProducts(this.props.products);
                        if (!this.walldialogVisible) {

                            this.walldialogVisible = true;
                            this.props.updateProducts(this.props.products);
                            this.dragging = false;
                        }

                    }
                    this.updateSelectionBox();
                    break;
                }
            }

        }
        else {
            // element über Wand hinaus geschoben?
            if (!this.isBetweenWalls(this.dragObject)) {
                this.resetobject = true;
            }
            return;

        }
    }

    selectedName = "";
    selectedobject: any;
    lastpos: any; lastdownpos: any;
    resetobject = false;
    walldialogVisible = false;
    windowwallchanged = false;
    async mousemoveCanvas(event) {
        this.moved = true;
        this.sceneHover(event);

        if (this.dragging && this.props.canvasView == "2d")
            this.controls.enablePan = false;
        if (!this.dragging && this.props.canvasView == "2d" && !this.windowwallchanged)
            this.controls.enablePan = true;

        if (this.dragging && this.props.canvasView == "3d") {

            this.updateProductsHelper(this.selectedobject, this.selectedobject?.userData.elementindex, true)
            await this.updateBoxHelper(null, 0x330000);

        }

        // möbel, fenster, tueren in 2D verschieben
        if (this.dragging && this.props.canvasView == "2d") {
            if (this.hoverobjectHelper)
                this.scene.remove(this.hoverobjectHelper);

            if (this.dragObject)
                ThreeUtils.createDmensionLabels(this.scene, this.dragObject, this.props.walls);

            this.mouse.x = (event.offsetX / this.canvasTarget.clientWidth) * 2 - 1;
            this.mouse.y = - (event.offsetY / this.canvasTarget.clientHeight) * 2 + 1;


            this.raycaster.setFromCamera(this.mouse, this.camera);
            this.intersects = (this.raycaster as THREE.Raycaster).intersectObjects(this.meshes, true);
            if (this.intersects.length === 0) return;

            ////////////////////
            this.resetobject = false;
            if (this.dragObject.userData.type === "window" || this.dragObject.userData.type === "door") {
                (this.raycaster as THREE.Raycaster).ray.intersectPlane(this.plane, this.pointOfIntersection);
                this.dragObject.position.copy(this.pointOfIntersection).add(this.shift);
                var wall = this.props.walls[this.dragObject.userData.wallindex];
                var p1 = new THREE.Vector2(-wall.p1.z, -wall.p1.x);
                var p2 = new THREE.Vector2(-wall.p2.z, -wall.p2.x);
                var p = new THREE.Vector2(this.pointOfIntersection.x, this.pointOfIntersection.z);
                p = Utils.mousewallprojection(p, p1, p2);

                var shifttest = new THREE.Vector3(this.shift.x, this.shift.y, this.shift.z)
                var p3d = new THREE.Vector3(p.x, 150, p.y);
                this.dragObject.position.copy(p3d).add(shifttest);

                var hitswall = this.hitsOtherWall();
                console.log('hitswall', hitswall);
                if (hitswall > -1 || !this.isBetweenWalls(this.dragObject)) {
                    this.updateSelectionBox();
                    console.log('hitswall', hitswall);
                    //                    this.mousedown = true;
                    this.windowwallchanged = true;
                    this.dragging = false;
                    ThreeUtils.createDmensionLabels(this.scene, null, this.props.walls);
                    (this.selectedobject as Mesh).userData.wallindex = hitswall;// - 1;
                    //                    var wi = this.dragObject.userData.wallindex;
                    var insertpoint = await Utils.calcWallInsertPoint(this.props.walls, this.selectedobject, true, this.props.interiors, hitswall);



                    // if (!insertpoint) {
                    //     this.resetobject = true;
                    //     this.dragObject.userData.wallindex = wi;
                    //     return;
                    // }

                    this.selectedobject.position.set(insertpoint.x, this.selectedobject.position.y, insertpoint.z);
                    this.selectedobject.rotation.y = insertpoint.rot;
                    //                    this.selectedobject.userData.wallindex = insertpoint.wall;
                    this.selectedobject.updateMatrix();


                    await this.setSelectedObject(this.selectedobject, 0xFF6600);
                    this.selectedobject.userData.interior.wall = this.selectedobject.userData.wallindex;
                    this.props.setInteriorPosition(-this.selectedobject.position.x, this.selectedobject.position.y, -this.selectedobject.position.z, this.selectedobject.userData.wallindex);
                    console.log('iserdata', this.selectedobject.userData)

                    return;

                    // deprecated
                    // await this.setSelectedObject(this.selectedobject, 0xFF0000);
                    // this.resetobject = true;
                }
                else {
                    this.updateSelectionBox();
                    await this.setSelectedObject(this.selectedobject, 0xFF6600);
                }
            }
            else {
                (this.raycaster as THREE.Raycaster).ray.intersectPlane(this.plane, this.pointOfIntersection);
                this.dragObject.position.copy(this.pointOfIntersection).add(this.shift);
                if (!this.isBetweenWalls(this.dragObject) || !this.isBetweenWalls(this.dragObject)) {
                    this.updateSelectionBox();
                    await this.setSelectedObject(this.selectedobject, 0xFF0000);
                    this.resetobject = true;
                }
                else {
                    this.updateSelectionBox();
                    await this.setSelectedObject(this.selectedobject, 0xFF6600);
                }

            }

        }

        // Elemente in 3D verschieben 
        if (this.dragging && this.props.canvasView == "3d" && this.dragObject.userData.type == "element" && this.props.selectableTypes[0] === "product" && this.moved) {
            this.moveElement(event);
            return;
        }
        // W2W verschieben
        if (this.dragging && this.props.canvasView == "3d" && this.dragObject.userData.type == "produkt" && this.props.selectableTypes[0] === "product" && this.moved) {
            if (this.dragObject.userData.isW2W) {
                await this.moveW2WSystem(event);
                return;
            }
        }

        // objekte in 3D verschieben
        if (this.dragging && this.props.canvasView == "3d" && this.dragObject.userData.type == "produkt" && this.props.selectableTypes[0] === "product" && this.moved) {
            //       console.log('move element', this.dragObject);
            this.mouse.x = (event.offsetX / this.canvasTarget.clientWidth) * 2 - 1;
            this.mouse.y = - (event.offsetY / this.canvasTarget.clientHeight) * 2 + 1;
            this.raycaster.setFromCamera(this.mouse, this.camera);
            this.intersects = (this.raycaster as THREE.Raycaster).intersectObjects(this.meshes, true);
            if (this.intersects.length === 0)
                return;

            // if (this.dragObject.userData.product.elements[elementindex].mountingSurface.type == "ceiling")
            //     isCeiling = true;
            // if (isCeiling) {
            //     this.plane.setFromNormalAndCoplanarPoint(new THREE.Vector3(0, 1, 0), this.intersects[0].point); // normale der Wand
            // }
            ////             this.plane.setFromNormalAndCoplanarPoint(new THREE.Vector3(0, 1, 0), this.intersects[0].point); // normale der Wand

            // verschieben 
            (this.raycaster as THREE.Raycaster).ray.intersectPlane(this.plane, this.pointOfIntersection);
            this.dragObject.position.copy(this.pointOfIntersection).add(this.shift);
            // W2W nur in wandrichtung verschieben
            // if (this.dragObject.userData.isW2W) {
            //     this.shift.x = 0;
            //     var p1 = new THREE.Vector2(-wall.p1.z, -wall.p1.x);
            //     var p2 = new THREE.Vector2(-wall.p2.z, -wall.p2.x);
            //     var p = new THREE.Vector2(this.pointOfIntersection.x, this.pointOfIntersection.z);
            //     p = Utils.mousewallprojection(p, p1, p2);
            //     var p3d = new THREE.Vector3(p.x, 150, p.y);
            //     this.dragObject.position.copy(p3d).add(this.shift);
            // }

            for (var i = 0; i < this.dragObject.userData.attachements?.length; i++) {
                var attachement = this.scene.getObjectByProperty('uuid', this.dragObject.userData.attachements[i]);
                (attachement as any)?.position.copy(this.pointOfIntersection).add(this.shift);
            }

            var pid = this.dragObject.userData.product.id;
            this.updateProductsHelper(null);  //this.updateProductsHelper(pid, this.dragObject.userData?.product?.elementindex);

            //////////////////// andere Wand Ãœberschneidung?
            this.resetobject = false;
            var wallhit = this.hitsOtherWall(this.dragObject);
            if (wallhit > -1) {

                for (var i = 0; i < this.props.products.length; i++) {
                    if (this.props.products[i].id == this.dragObject.userData.product.id) {

                        await this.setSelectedObject(this.selectedobject, 0xFF0000);

                        if (this.dragObject.userData.isRopeSystem) {
                            this.resetobject = true;

                            break;
                        }

                        if (wallhit == 999) { // ceiling/floor hit
                            this.resetobject = true;
                            break;
                        }
                        var elementindex = this.dragObject.userData.product.elementindex;
                        var de = this.props.products[i].elements[elementindex];
                        if (de.mountingSurface.type == "ceiling" || de.mountingSurface.type == "floor") {
                            this.resetobject = true;
                            break;
                        }
                        else {
                            var from = de.mountingSurface.index;
                            var to = wallhit;
                            if (from != to)
                                console.log('wall hit (from,to):', from, to)
                            de.mountingSurface.index = wallhit;
                            //        if (!this.walldialogVisible)
                            //            this.props.updateProducts(this.props.products);
                            if (!this.walldialogVisible) {

                                this.walldialogVisible = true;
                                this.props.updateProducts(this.props.products);
                                this.dragging = false;
                            }

                        }
                        this.updateSelectionBox();
                        break;
                    }
                }

            }
            else {
                // element über Wand hinaus geschoben?
                if (!this.isBetweenWalls(this.dragObject)) {
                    this.resetobject = true;
                }
                return;


                await this.setSelectedObject(this.selectedobject, 0xFF6600);
                this.updateSelectionBox();
            }


        }


    }

    selectedelementindex = null;
    async sceneMouseUp(e) {
        localStorage.setItem('camerapos', JSON.stringify(this.camera.position));
        this.selectedelementindex = e;

        this.windowwallchanged = false;
        this.mousedown = false;
        if (this.props.canvasView == "3d" && this.controls)
            this.controls.enableRotate = true;
        if (this.dragging && this.props.canvasView == "2d") {
            this.props.setInteriorPosition(-this.selectedobject.position.x, this.selectedobject.position.y, -this.selectedobject.position.z);
            this.controls.mouseButtons =
            {
                LEFT: THREE.MOUSE.PAN,
                MIDDLE: THREE.MOUSE.DOLLY,
                RIGHT: null
            }
        }

        ThreeUtils.createDmensionLabels(this.scene, null, this.props.walls);
        if (this.dragObject && this.props.canvasView == "2d")
            if (this.resetobject) {
                this.dragObject?.position.copy(this.lastdownpos);
                this.setSelectedObject(this.selectedobject, 0xFF6600);
                this.props.setInteriorPosition(-this.selectedobject.position.x, this.selectedobject.position.y, -this.selectedobject.position.z);


            }
        if (this.dragObject?.userData.type === "window" || this.dragObject?.userData.type === "door") {
            this.renderer.render(this.scene, this.camera); // muss for positionsupdates erfolgen!
            //   await this.recreateAndCutWall(this.dragObject.userData.wallindex);
        }

        // element auf seilsystem click
        if (this.dragObject?.visible && this.dragObject?.userData.posOnRope && this.props.canvasView == "3d") {
            var pid = this.dragObject.userData.element.productid; // this.dragObject.userData.product?.id;
            var eindex = this.dragObject.userData.elementindex;
            var packindex = this.dragObject.userData.packindex;
            this.props.setSelectedProductId(pid, packindex, null);
            console.log('element auf seilsystem click', pid, eindex, packindex);
        }
        // product click
        if (this.props.canvasView == "3d" && this.dragObject?.userData?.type == "produkt" && this.props.selectableTypes[0] === "product" && !this.moved) {
            if (this.dragObject.userData.isRopeSystem) {
                this.dragging = false;
                return;
            }
            var pid = this.dragObject.userData.product.id;
            if (this.dragObject.userData.isRopeSystem)
                this.props.setSelectedProductId(pid, 0, null);
            else
                this.props.setSelectedProductId(pid, this.hoverobj?.userData?.product?.elementindex, e);
            this.updateProductsHelper(pid, this.hoverobj.userData?.product?.elementindex);
            //    this.updateProductsHelper(pid)
        }
        if (!this.dragObject) {
            this.props.setSelectedProductId(null, null, null);
        }

        // element move end
        if (this.dragging && this.props.canvasView == "3d" && this.dragObject.userData.type == "element" && this.props.selectableTypes[0] === "product" && this.moved) {
            console.log('element move end', this.dragObject);

            var productscopy = JSON.parse(JSON.stringify(this.props.products));
            for (var i = 0; i < this.props.products.length; i++) {
                for (var k = 0; k < productscopy[i].elements.length; k++) {
                    if (this.dragObject.userData.element.id === this.props.products[i].elements[k].id) {
                        var productpos1 = {
                            z: this.dragObject.userData.productpos.x,
                            //     y: this.dragObject.position.y,
                            x: this.dragObject.userData.productpos.z
                        };

                        var dx = this.dragObject.position.x;// - productpos1.x;
                        var dz = this.dragObject.position.z;// - productpos1.z;
                        var rotated = Utils.rotatePointY(dx, dz, -this.dragObject.userData.rot);

                        // productscopy[i].elements[k].position.z = -this.dragObject.position.x + productpos1.x //- this.dragObject.userData.wireLength / 2;
                        // productscopy[i].elements[k].position.x = -this.dragObject.position.z + productpos1.z;
                        productscopy[i].elements[k].position.z = - rotated[0] + productpos1.x //- this.dragObject.userData.wireLength / 2;
                        productscopy[i].elements[k].position.x = - rotated[1] + productpos1.z;

                        console.log('newpos', productscopy[i].elements[k].position);

                    }
                }
            }

            console.log('updateelement', productscopy);
            this.props.updateProducts(productscopy, false);
            this.setSelectedObject(this.selectedobject, 0xFF6600);
            //  this.props.setSelectedProductId(pid, this.hoverobj?.userData?.product?.elementindex, e);


        }
        if (this.dragging && this.props.canvasView == "3d" && this.dragObject.userData.type == "produkt" && this.props.selectableTypes[0] === "product" && this.moved) {
            await this.setSelectedObject(null, 0x0000ff);

            if (this.resetobject) {
                this.dragObject?.position.copy(this.lastMousedownpos);
                //  (this.raycaster as THREE.Raycaster).ray.intersectPlane(this.plane, this.lastdownpos);
                // && this.dragObject.position.copy(this.pointOfIntersection).add(this.shift);
                for (var i = 0; i < this.dragObject.userData.attachements?.length; i++) {
                    var attachement = this.scene.getObjectByProperty('uuid', this.dragObject.userData.attachements[i]);
                    (attachement as any)?.position.copy(this.lastMousedownpos); //?.position).add(this.lastdownpos);
                }

                this.setSelectedObject(this.selectedobject, 0xFF6600);
                this.props.updateProducts(this.props.products, false);
            }
            else {

                var productscopy = JSON.parse(JSON.stringify(this.props.products));
                for (var i = 0; i < this.props.products.length; i++) {
                    if (this.dragObject.userData.product.id === this.props.products[i].id) {
                        // this.ignoreUpdate = true;
                        //   this.props.products[0].elements[0].position.x = 100;// zum tEst
                        if (this.dragObject.userData.ropesystemwidth) {
                            var productpos = {
                                x: this.dragObject.position.z,// - this.dragObject.userData.ropesystemwidth / 2,
                                y: this.dragObject.position.y,
                                z: this.dragObject.position.x// - this.dragObject.userData.ropesystemlength / 2
                            };
                            productscopy[i].elements[0].position.x = -productpos.x;
                            productscopy[i].elements[0].position.y = productpos.y;
                            productscopy[i].elements[0].position.z = -productpos.z;

                            for (var j = 0; j < productscopy.length; j++) {
                                for (var k = 0; k < productscopy[j].elements.length; k++) {
                                    if (productscopy[j].elements[k].provider === productscopy[i].elements[0].id) {
                                        var elementdelta = {
                                            x: productscopy[i].elements[0].position.x - this.dragObject.userData.productpos.x,
                                            y: productscopy[i].elements[0].position.y - this.dragObject.userData.productpos.y,
                                            z: productscopy[i].elements[0].position.z - this.dragObject.userData.productpos.z
                                        };

                                        productscopy[j].elements[k].position.x += elementdelta.x;
                                        //productscopy[j].elements[k].position.y = elementpos.y;
                                        productscopy[j].elements[k].position.z += elementdelta.z;



                                    }
                                }
                            }

                            this.scene.traverse(x => {
                                if ((x?.userData?.type === "element") && x?.userData?.product?.id === this.dragObject.userData.product.id) {

                                    x.userData.productpos.x = JSON.parse(JSON.stringify(-productpos.x));
                                    x.userData.productpos.z = JSON.parse(JSON.stringify(-productpos.z))

                                }
                            });
                        }

                        // var groupcenter = { x: -product.elements[0].position.x + width / 2, y: product.elements[0].position.y, z: -product.elements[0].position.z + length / 2 };
                        var ud = this.dragObject.userData;
                        var ei = ud.elementindex;
                        var el = productscopy[i].elements[ei];
                        if (el) {
                            console.log('#elementinedex: ', ei, el);
                            el.position.x = -(this.dragObject.position.z + ud.offsets.walloffset * ud.wallnormal[1]);
                            if (el.mountingSurface.type !== "ceiling")
                                el.position.y = this.dragObject.position.y;
                            el.position.z = -(this.dragObject.position.x + ud.offsets.walloffset * ud.wallnormal[0]);
                            console.log(el.position);
                        }
                        break;
                    }
                    // newgltf.userData.offsets = offsets;
                    // newgltf.userData.wallnormal = wallnormal;
                    // newgltf.userData.isElement = true;
                    this.setSelectedObject(this.selectedobject, 0xFF6600);
                }

            }

            console.log('updateproducts', productscopy);
            if (productscopy)
                this.props.updateProducts(productscopy, false);

        }

        this.dragObject = null;
        this.dragging = false;
        this.moved = false;
    }


    updateProductsHelper(productid: string, element: number = null, selection = false) {
        console.log('updateproductshelper', productid, element);
        try {

            var toremove = [];
            this.scene.traverse(x => {
                if (x?.userData?.type === "produkthelper") {
                    toremove.push(x);
                }
                if (selection)
                    if (x?.userData?.type === "produkthelperselection") {
                        toremove.push(x);
                    }

            });
            for (var i = 0; i < toremove.length; i++) {
                this.scene.remove(toremove[i]);
            }

            if (productid)
                this.scene.traverse(x => {
                    if ((x?.userData?.type === "produkt" || x?.userData?.type === "element") && (x?.userData?.product?.id === productid || x?.userData?.element?.productid === productid)) {
                        var bbox = ThreeUtils.getBBox(x);

                        //      this.create3DMarker(bbox, 60, 10, 10);
                        // if (this.props.canvasView == "2d") {
                        //     (this.selectBoxHelper.material as any).depthTest = false;
                        //     (this.selectBoxHelper.material as any).depthWrite = false;
                        // }
                        console.log('element', element, selection);
                        if (selection) {
                            bbox = bbox.expandByScalar(2.3);
                            var newhelper = new THREE.Box3Helper(bbox, new THREE.Color(0xFF6600));
                            var dd = this.selectedobject.userData;
                            if (x.userData.product.elementindex == element || x.userData.elementindex == element)
                                //   if (dd.elementindex == element)
                                newhelper = new THREE.Box3Helper(bbox, new THREE.Color(0x33FF00));

                            newhelper.userData.type = "produkthelperselection";
                        }
                        else {
                            bbox = bbox.expandByScalar(2);
                            var newhelper = new THREE.Box3Helper(bbox, new THREE.Color(0xaa6644));
                            if (x.userData.product.elementindex == element)
                                newhelper = new THREE.Box3Helper(bbox, new THREE.Color(0xaa4444));

                            newhelper.userData.type = "produkthelper";
                        }
                        newhelper.visible = true;
                        newhelper.renderOrder = 99999;
                        //                        console.log('x?.userData', x?.userData)
                        if ((x?.userData?.type === "produkt" && !x?.userData?.posOnRope) || (x?.userData?.posOnRope && element != null))
                            if (x?.visible)
                                this.scene.add(newhelper);

                    }
                });
        } catch (e) {
            console.log('e', e);
        }
    }


    async updateBoxHelper(selectedobject, color) {
        var bbox = await ThreeUtils.getBBox(selectedobject);
        if (this.selectBoxHelper)
            this.scene.remove(this.selectBoxHelper);
        if (!bbox) {

            return;
        }

        bbox = bbox.expandByScalar(2);
        //      this.create3DMarker(bbox, 60, 10, 10);
        this.selectBoxHelper = new THREE.Box3Helper(bbox, new THREE.Color(color));
        this.selectBoxHelper.geometry;
        if (this.props.canvasView == "2d") {
            (this.selectBoxHelper.material as any).depthTest = false;
            (this.selectBoxHelper.material as any).depthWrite = false;
        }

        this.selectBoxHelper.visible = true;
        this.selectBoxHelper.renderOrder = 99999;

        this.scene.add(this.selectBoxHelper);
    }

    async setSelectedObject(selectedobject, color) {
        //    console.log('setSelectedObject', this.selectBoxHelper, selectedobject)
        selectedobject?.updateMatrix();
        this.renderer.render(this.scene, this.camera);


        var productid = selectedobject?.userData?.product?.id;
        var elementindex = selectedobject?.userData?.elementindex;
        if (elementindex != undefined)
            await this.updateProductsHelper(productid, elementindex, true)
        if (!selectedobject)
            await this.updateProductsHelper(null, null, true)
        console.log("selectedobject", selectedobject, elementindex, productid)

        await this.updateBoxHelper(selectedobject, color);
    }


    getObjectRoot(obj) {
        var child = obj;
        while (obj?.parent?.type !== "Scene" && obj && obj?.parent)
            obj = obj.parent;

        return obj;
    }


    async setInteriorScale(selectedobject, width, height, depth) {
        var jsonfile = this.selectedobject.userData.filename.replace('.gltf', '.json');

        try {
            this.selectedobject.userData.calculationModel = await (await fetch(jsonfile).then()).json().catch(e => console.log('Connection error', e)); // TODO: nur 1x laden

            if (this.selectedobject.userData.calculationModel) {
                //await ThreeUtils.setTransformations(this.scene, selectedobject.userData.calculationModel, selectedobject, 1, 1, 1);
                var originalbb = ThreeUtils.getBBox(selectedobject);
                var owidth = Math.abs(originalbb.max.x - originalbb.min.x);
                var oheight = Math.abs(originalbb.max.y - originalbb.min.y);
                var odepth = Math.abs(originalbb.max.z - originalbb.min.z);
                selectedobject.userData.originalwidth = owidth;
                selectedobject.userData.originalheight = oheight;
                selectedobject.userData.originaldepth = odepth;
                selectedobject.userData.width = width;
                selectedobject.userData.height = height;
                selectedobject.userData.depth = depth;

                this.selectedobject.userData.width = width;
                console.log('settranfos: ', width, owidth, height, oheight, depth, odepth)
                return true;
            }
        } catch (err) {
            console.log('json not found');
        }

        return false;
    }

    // erstellt alle Assets inkl. Fenster beim ersten Laden
    async createInteriors(selectableTypes) {
        console.log('createinterios', this.props.interiors, this.meshes);


        var toremove = [];
        this.scene.traverse(x => {
            if (x?.userData?.type === "window" || x?.userData?.type === "door" || x?.userData?.type === "furniture" || x?.userData?.type === "lamp" || x?.userData?.type === "cuthelper" || x?.userData?.type === "windowhelper") {
                toremove.push(x);
            }
        })
        for (var i = 0; i < toremove.length; i++) {
            this.scene.remove(toremove[i]);
        }
        for (var i = 0; i < this.meshes.length; i++) {
            if (this.meshes[i].userData?.type === "window" || this.meshes[i].userData?.type === "door" || this.meshes[i].userData?.type === "furniture" || this.meshes[i].userData?.type === "lamp" || this.meshes[i].userData?.type === "cuthelper" || this.meshes[i].userData?.type === "windowhelper") {
                console.log('splice', i, this.meshes[i].userData.type);
                this.meshes.splice(i, 1);
                i--;
            }
        }


        for (var i = 0; i < this.props.interiors.length; i++) {
            try {
                var ni = this.props.interiors[i];
                var showhelper = false;
                if (selectableTypes)
                    if (selectableTypes[0] === "door")
                        showhelper = true;

                if (ni.type === "window" || ni.type === "door") {
                    console.log('create window', ni);
                    this.selectedobject = (await this.addGltf2Scene(ni.threeDModel, ni.type, true, { x: 0, y: 0, z: 0 }, {}, 1, true, true, true, { interior: ni })).scene;

                    this.selectedobject.position.set(-ni.position.x, ni.position.y, -ni.position.z);
                    var insertpoint = await Utils.calcWallInsertPoint(this.props.walls, this.selectedobject, true, this.props.interiors, ni.wall);
                    this.selectedobject.userData.wallindex = ni.wall; // insertpoint.wall;
                    if (await this.setInteriorScale(this.selectedobject, ni.width, ni.height, ni.depth)) // HACL, falscher Wert in API
                    {
                        var ow = this.selectedobject.userData.originalwidth;
                        var oh = this.selectedobject.userData.originalheight;
                        var od = this.selectedobject.userData.originaldepth;
                        // if (!ow) ow = this.selectedobject.userData.interior.width;
                        // if (!oh) oh = this.selectedobject.userData.interior.height;
                        // if (!od) od = this.selectedobject.userData.interior.depth;
                        if (ni.type == "window" || ni.type == "door") {
                            console.log('###TEST', ni)

                            this.selectedobject.userData.width = ni.width;// this.selectedobject.userData.originalwidth;
                            this.selectedobject.userData.height = ni.height;// this.selectedobject.userData.originalheight;
                            this.selectedobject.userData.depth = ni.depth; //this.selectedobject.userData.originaldepth;
                        }
                        else {
                            this.selectedobject.userData.width = this.selectedobject.userData.interior.width;
                            this.selectedobject.userData.height = this.selectedobject.userData.interior.height;
                            this.selectedobject.userData.depth = this.selectedobject.userData.interior.depth;
                        }

                        this.selectedobject.rotation.y = insertpoint.rot;

                        await ThreeUtils.setTransformations(this.scene, this.selectedobject.userData.calculationModel, this.selectedobject, ni.width, ni.height, ni.depth, ow, oh, od);
                        if (ni.scale) {
                            if (ni.scale.z == -1)
                                (this.selectedobject as Mesh).scale.x = ni.scale.z * Math.abs((this.selectedobject as Mesh).scale.z);
                            if (ni.scale.x == -1)
                                (this.selectedobject as Mesh).scale.z = ni.scale.x * Math.abs((this.selectedobject as Mesh).scale.x);
                        }

                        // await ThreeUtils.setTransformations(this.scene, this.selectedobject.userData.calculationModel, this.selectedobject, this.selectedobject.userData.interior.width, this.selectedobject.userData.interior.height, this.selectedobject.userData.interior.depth, owidth, oheight, odepth);
                        // if (ni.type !== "window" && ni.type !== "door")
                        //     (this.selectedobject as Mesh).rotation.y = (Math.PI / 180 * ni.rotate);


                    } else {


                        var originalbb = ThreeUtils.getBBox(this.selectedobject);
                        var owb = Math.abs(originalbb.max.x - originalbb.min.x);
                        var ohb = Math.abs(originalbb.max.y - originalbb.min.y);
                        var odb = Math.abs(originalbb.max.z - originalbb.min.z);
                        this.selectedobject.userData.originalwidth = owb;
                        this.selectedobject.userData.originalheight = ohb;
                        this.selectedobject.userData.originaldepth = odb;
                        this.selectedobject.userData.width = owb; this.selectedobject.userData.interior.width;
                        this.selectedobject.userData.height = ohb; this.selectedobject.userData.interior.height;
                        this.selectedobject.userData.depth = odb; this.selectedobject.userData.interior.depth;



                        this.selectedobject.rotation.y = insertpoint.rot;

                        await ThreeUtils.setTransformations(this.scene, this.selectedobject.userData.calculationModel, this.selectedobject, ni.width, ni.height, ni.depth, owb, ohb, odb);
                        if (ni.scale) {
                            if (ni.scale.z == -1)
                                (this.selectedobject as Mesh).scale.x = ni.scale.z * Math.abs((this.selectedobject as Mesh).scale.z);
                            if (ni.scale.x == -1)
                                (this.selectedobject as Mesh).scale.z = ni.scale.x * Math.abs((this.selectedobject as Mesh).scale.x);
                        }

                    }

                    this.renderer.render(this.scene, this.camera);
                    //console.log('ni', insertpoint.rot)
                    //    this.selectedobject.position.y = 200;
                    this.cutHelper(this.selectedobject, true);


                }
                else {
                    this.selectedobject = (await this.addGltf2Scene(ni.threeDModel, ni.type, showhelper, { x: ni.position.x, y: ni.position.y, z: ni.position.z }, {}, 1, true, true, true, { interior: ni })).scene;

                    var jsonfile = this.selectedobject.userData.filename.replace('.gltf', '.json');
                    try {
                        this.selectedobject.userData.calculationModel = await (await fetch(jsonfile).then()).json().catch(); // TODO: nur 1x laden
                    } catch (err) {
                        console.log('json not found');
                    }

                    var originalbb = ThreeUtils.getBBox(this.selectedobject);
                    var owb = Math.abs(originalbb.max.x - originalbb.min.x);
                    var ohb = Math.abs(originalbb.max.y - originalbb.min.y);
                    var odb = Math.abs(originalbb.max.z - originalbb.min.z);
                    this.selectedobject.userData.originalwidth = owb;
                    this.selectedobject.userData.originalheight = ohb;
                    this.selectedobject.userData.originaldepth = odb;
                    this.selectedobject.userData.width = this.selectedobject.userData.interior.width;
                    this.selectedobject.userData.height = this.selectedobject.userData.interior.height;
                    this.selectedobject.userData.depth = this.selectedobject.userData.interior.depth;


                    // console.log('#TRAFO', this.selectedobject.userData.calculationModel, this.selectedobject, ni.width, ni.height, ni.depth, ow, oh, od);
                    await ThreeUtils.setTransformations(this.scene, this.selectedobject.userData.calculationModel, this.selectedobject, ni.width, ni.height, ni.depth, owb, ohb, odb);
                    if (ni.scale) {
                        if (ni.scale.z == -1)
                            (this.selectedobject as Mesh).scale.x = ni.scale.z * Math.abs((this.selectedobject as Mesh).scale.z);
                        if (ni.scale.x == -1)
                            (this.selectedobject as Mesh).scale.z = ni.scale.x * Math.abs((this.selectedobject as Mesh).scale.x);
                    }

                    if (ni.rotate)
                        this.selectedobject.rotation.y = Math.PI / 180 * ni.rotate;
                    this.selectedobject.updateMatrix();
                    this.selectedobject.updateMatrixWorld(true);

                }

            }
            catch (e) {
                console.log(e);
            }
        }


        // Fenster, Türen schneiden
        for (var i = this.meshes.length - 1; i > 0; i--) {
            if (this.meshes[i].userData.type == "wall") {
                this.renderer.render(this.scene, this.camera);
                this.cutWall(this.meshes[i], i);
            }
            if (this.meshes[i].userData.type == "sockelleiste") {
                this.renderer.render(this.scene, this.camera);
                this.cutWall(this.meshes[i], i);
            }

        }




        if (this.props.selectableTypes[0] === "product")
            await this.createProducts();

    }

    getCamera(productid: string) {
        for (var i = 0; i < this.props.products.length; i++) {
            if (this.props.products[i].id === productid) {
                var p = this.props.products[i];
                if (p.elements)
                    if (p.elements[0].mountingSurface.type === "wall") {
                        // Wand von product
                        var wallindex = p.elements[0].mountingSurface.index;
                        // gegenüberliegende Wand errechnen, zur Ei
                        if (wallindex + 2 < this.props.walls.length) {
                            this.props.setCameraIndex(wallindex + 2);
                            return this.viewpoints[wallindex + 2];
                        }
                        else {
                            this.props.setCameraIndex(wallindex - 2);
                            return this.viewpoints[wallindex - 2];
                        }
                    }



            }
        }

        return null;
    }


    async createProducts() {
        console.log('create products', this.selectBoxHelper, this.selectedobject);

        var toremove = [];
        this.scene.traverse(x => {
            if (x?.userData?.type === "produkt") {
                toremove.push(x);
            }
            if (x?.userData?.type === "rope") {
                toremove.push(x);
            }
            if (x?.userData?.type === "ropeEnd") {
                toremove.push(x);
            }
            if (x?.userData?.type === "productattachement") {
                toremove.push(x);
            }
            if (x?.userData?.type === "element") {
                toremove.push(x);
            }
        });
        for (var i = 0; i < toremove.length; i++) {
            this.scene.remove(toremove[i]);
        }

        for (var j = this.meshes.length - 1; j > -1; j--) {
            try {

                if (this.meshes[j].userData.type == "produkt")
                    this.meshes.splice(j, 1);
                if (this.meshes[j].userData.type == "rope")
                    this.meshes.splice(j, 1);
                if (this.meshes[j].userData.type == "ropeEnd")
                    this.meshes.splice(j, 1);
                if (this.meshes[j].userData.type == "productattachement")
                    this.meshes.splice(j, 1);
                if (this.meshes[j].userData.type == "element")
                    this.meshes.splice(j, 1);
            } catch (e) {

            }

            // if (this.meshes[j].uuid == toremove[i].uuid) {
            //     this.meshes[j].splice(j, 1); //break;
            // }
        }

        for (var i = 0; i < this.props.products.length; i++) {
            var p = this.props.products[i];

            for (var j = 0; j < p.elements.length; j++) {
                if (!p.elements[0]?.wireLength)
                    if (p.elements[j])
                        if (!(p.elements[j].isHidden)) {

                            var el = p.elements[j];
                            var angleY = 0;
                            var angleX = 0;
                            var angleZ = 0;
                            if (el.mountingSurface?.type.indexOf('wire') > -1)
                                continue;

                            if (el.mountingSurface?.type === 'wall') {
                                var wall = this.props.walls[el.mountingSurface.index];
                                angleY = Utils.calcWallRotation(wall);
                            }
                            if (el.mountingSurface?.type === 'ceiling') {
                                angleX = 90 * Math.PI / 180;
                            }
                            if (el.rotation !== 0) {
                                if (el.mountingSurface?.type === 'floor') {
                                    angleY = el.rotation * Math.PI / 180
                                } else {
                                    angleZ = el.rotation * Math.PI / 180
                                }
                            }

                            var rotation = { x: angleX, y: angleY, z: angleZ };
                            if (el.position != undefined && el.mountingSurface !== undefined) {

                                var position = { x: el.position.z, y: el.position.y, z: el.position.x };

                                var wall = this.props.walls[el.mountingSurface.index];
                                var wallnormal = Utils.wallnormal(wall);

                                p.elementindex = j;
                                var p2 = JSON.parse(JSON.stringify(p));
                                var newgltf = null;
                                if (el.mountingSurface?.type === 'ceiling')
                                    newgltf = (await this.addGltf2Scene(p.threeDModel.product, "produkt", false, position, rotation, 1, false, false, true, { product: p2 })).scene;
                                else
                                    newgltf = (await this.addGltf2Scene(p.threeDModel.product, "produkt", false, position, rotation, 1, true, false, true, { product: p2 })).scene;
                                // Zubehör/Aufhängung
                                var offsets = await this.modelManager.createProductAttachments(p, el, rotation, this.scene, this.props.walls, newgltf);
                                var walloffset = offsets.walloffset;
                                var ceilingoffset = offsets.ceilingoffset;
                                //  console.log('offset', offsets);
                                //   newgltf.position.set(newgltf.position.x - wallnormal[0] * walloffset, newgltf.position.y, newgltf.position.z - wallnormal[1] * walloffset);
                                if (el.mountingSurface.type == "wall") {
                                    //   walloffset = 5;
                                    newgltf.position.set(newgltf.position.x - wallnormal[0] * walloffset, newgltf.position.y, newgltf.position.z - wallnormal[1] * walloffset);
                                }
                                if (el.mountingSurface.type == "ceiling") {
                                    //  ceilingoffset = 5;
                                    console.log('ceilingproduct', newgltf.position);
                                    newgltf.rotateZ(Math.PI / 2);
                                    newgltf.position.set(newgltf.position.x, newgltf.position.y - ceilingoffset, newgltf.position.z);
                                }
                                newgltf.userData.offsets = offsets;
                                newgltf.userData.wallnormal = wallnormal;
                                newgltf.userData.isElement = true;
                                newgltf.userData.mountingSurface = el.mountingSurface.type;
                                newgltf.userData.elementindex = j;
                                if (p.elements[j].isHidden) {

                                    // newgltf.visible = false;
                                    // for (var a = 0; a < p[i].userData.attachements.length; a++) {
                                    //     var aid = p[i].userData.attachements[a];

                                    // }
                                    //                    productgltf.userData.attachements.push(newsb.uuid);
                                }

                                this.meshes.push(newgltf);
                            }
                            // }

                        }

            }

            //      this.setSelectedObject(this.selectedobject);

        }


        await ThreeUtils.createRopeSystem(this.gltfs, this.meshes, this.loader, this.scene, this.SERVERURL, this.props.products);

    }

    productsVersion = -1;
    ignoreUpdate = false;
    async componentDidUpdate(prevProps: any, prevState: any, snapshot: any) {
        if (this.ignoreUpdate) {
            this.ignoreUpdate = false;
            return;
        }
        console.log('didupate', prevProps, prevState, snapshot)
        var diffPatcher = new DiffPatcher();
        try {
            const prevp = JSON.parse(JSON.stringify(prevProps.products));
            const nowp = JSON.parse(JSON.stringify(this.props.products));
            //    console.log('prevp', prevp, prevState, snapshot)
            const diffp = diffPatcher.diff(prevp, nowp);
            //   console.log('diffp', diffp);
        } catch (err) {

        }

        const prev = JSON.parse(JSON.stringify(prevProps));
        const now = JSON.parse(JSON.stringify(this.props));

        // https://www.npmjs.com/package/jsondiffpatch
        // https://github.com/benjamine/jsondiffpatch/blob/HEAD/docs/deltas.md
        const diff = diffPatcher.diff(prev, now);
        console.log('diff', diff);
        // if (diff.roomid?.length === 2)
        //     if (diff.roomid[0] && diff.roomid[1]) {

        if (diff?.products)
            if (diff?.products[0]?.elementindex?.length == 3)
                if (diff?.products[0]?.elementindex[2] == 0) {
                    return;
                }

        //   if (diff?.walls && this.props.selectableTypes[0] === "product") {
        if (diff?.roomId) {
            // await this.clearScene();
            // await this.initScene();
            // //      this.componentWillUnmount();
            // // this.loader = new GLTFLoader();
            // // this.mouse = new THREE.Vector2(1, 1);
            // //    await this.componentDidMount();
            // await this.createRoom();

            // // await this.createFloor(this.props.walls);
            // // await this.createCeiling(this.props.walls);
            // // await this.createWalls(this.props.walls);

            // await this.createInteriors(this.props.selectableTypes);
            // await this.createProducts();
            // this.innerView();
            // this.setCamera(this.viewpoints[0]);

            // //            window.location.reload();       // TODO: übler hack get besser
            // return;
        }

        if (diff?.selectableTypes) {
            await this.setSelectedObject(null, 0x0000ff);


            if (diff.selectableTypes[0] == "product") {
                this.objectboxes = [];
                this.cutHelpers = [];
                //  this.meshes = [];
                //this.clearScene();
                await this.createWalls(this.props.walls);
                //this.createRoom();

                await this.createInteriors(diff.selectableTypes);
                this.updateObjects();

            }



            this.scene.traverse(x => {
                if (x?.userData?.type === "windowhelper") {
                    if (diff.selectableTypes[0] == "product")
                        x.visible = false;
                    else
                        x.visible = true;
                }
            })

        }




        // 
        if (diff?.cameraIndex) {
            if (diff?.cameraIndex.length == 2) {
                var ci = diff?.cameraIndex[1] - 1; // this.viewpoints.length - diff?.cameraIndex[1];
                // if (ci == this.viewpoints.length) ci = 0;
                // if (this.props.walls.length === 3) {// offener Raum
                //     ci = diff?.cameraIndex[1] - 1;
                //     if (ci == -1) ci = 3;
                // }
                console.log('set cam', ci, diff?.cameraIndex)
                this.setCamera(this.viewpoints[ci]);

            }
        }

        if (diff?.productsVersion) {
            console.log('#PRODUCTSVERSION', diff?.productsVersion);
            this.updateProductsHelper(null);
            this.dragging = false;
            this.mousedown = false;
            this.walldialogVisible = false;

            try {
                // added/edited
                //  if (propslength > 2) { // && firstkey[0] !== "_") {
                console.log('added products');

                // alle Produkte neu generieren,
                if (diff?.productsVersion[1])
                    await this.createProducts();


                var pid = this.selectedobject?.userData?.product?.id;
                //   await this.setSelectedObject(this.selectedobject, 0xFF6600);
                this.updateProductsHelper(null);
                this.setSelectedObject(null, 0xFF6600);
            }
            catch (err) {
                console.log(err);
            }
        }

        if (diff?.interiors) {
            var firstkey = Object.keys(diff?.interiors)[0];
            var firstprop = diff?.interiors[Object.keys(diff?.interiors)[0]];
            var propslength = Object.keys(diff?.interiors).length;
            var prelastkey = Object.keys(diff?.interiors)[propslength - 2];

            try {
                // added
                if (propslength == 2 && firstkey[0] !== "_") {
                    var ni = diff.interiors[Object.keys(diff?.interiors)[propslength - 2]][0];
                    if (ni) {

                        console.log('added', ni.type, ni, this.selectedobject);
                        if (ni.type == "furniture" || ni.type == "lamp") {

                            var ip = Utils.calcRoomInsertPoint(this.props.walls);
                            var posy = 0;
                            if (ni.type == "lamp")
                                posy = this.props.walls[0].h;

                            if (ni.position?.y)
                                posy = ni.position?.y;

                            this.selectedobject = (await this.addGltf2Scene(ni.threeDModel, ni.type, false, { x: ip.z, y: posy, z: ip.x }, {}, 1, true, true, true, { interior: ni })).scene;

                            console.log('added', this.selectedobject)
                        }
                        if (ni.type == "window" || ni.type == "door") {
                            this.selectedobject = (await this.addGltf2Scene(ni.threeDModel, ni.type, true, { x: 0, y: 0, z: 0 }, {}, 1, true, true, true, { interior: ni })).scene;
                            var insertpoint = await Utils.calcWallInsertPoint(this.props.walls, this.selectedobject, true, this.props.interiors);
                            this.selectedobject.position.set(insertpoint.x, this.selectedobject.position.y, insertpoint.z);

                            this.selectedobject.rotation.y = insertpoint.rot;
                            this.selectedobject.userData.wallindex = insertpoint.wall;

                            console.log('window/door added', this.selectedobject)
                        }


                        // initiale größe setzen
                        try {
                            var jsonfile = this.selectedobject.userData.filename.replace('.gltf', '.json');
                            try {
                                this.selectedobject.userData.calculationModel = await (await fetch(jsonfile).then()).json().catch(e => console.log('Connection error', e)); // TODO: nur 1x laden
                            } catch (err) {
                                console.log('json not found');
                            }

                            await ThreeUtils.setTransformations(this.scene, this.selectedobject.userData.calculationModel, this.selectedobject, 10, 10, 10, 10, 10, 10);
                            var originalbb = ThreeUtils.getBBox(this.selectedobject);
                            var owidth = Math.abs(originalbb.max.x - originalbb.min.x);
                            var oheight = Math.abs(originalbb.max.y - originalbb.min.y);
                            var odepth = Math.abs(originalbb.max.z - originalbb.min.z);

                            this.selectedobject.userData.originalwidth = owidth;
                            this.selectedobject.userData.originalheight = oheight;
                            this.selectedobject.userData.originaldepth = odepth;
                            if (ni.type == "window" || ni.type == "door") {
                                this.selectedobject.userData.depth = odepth;
                            }
                            else {
                                this.selectedobject.userData.depth = this.selectedobject.userData.interior.depth;
                            }
                            this.selectedobject.userData.width = this.selectedobject.userData.interior.width;
                            this.selectedobject.userData.height = this.selectedobject.userData.interior.height;


                            await ThreeUtils.setTransformations(this.scene, this.selectedobject.userData.calculationModel, this.selectedobject, this.selectedobject.userData.interior.width, this.selectedobject.userData.interior.height, this.selectedobject.userData.interior.depth, owidth, oheight, odepth);
                            if (ni.type !== "window" && ni.type !== "door")
                                (this.selectedobject as Mesh).rotation.y = (Math.PI / 180 * ni.rotate);


                            this.findFreeRoomPosition(this.selectedobject);
                        } catch (e) {
                            console.error(e);
                        }

                        this.props.setSelectedInteriorId(this.selectedobject.userData?.interior?.id);
                        this.props.setInteriorPosition(-this.selectedobject.position.x, this.selectedobject.position.y, -this.selectedobject.position.z);
                        this.setSelectedObject(this.selectedobject, 0xFF6600);

                        // TODO standardwerte
                        if (ni.type == "window" || ni.type == "door") {
                            // TODO: größe aus Standardwerten
                            // HACK
                            if (ni.type == "window") {
                                // this.selectedobject.userData.width = 120;
                                // this.selectedobject.userData.height = 140;

                                if (ni.position?.y)
                                    this.selectedobject.position.y = ni.position?.y;
                                else
                                    this.selectedobject.position.y = 80;

                                this.selectedobject.userData.depth = odepth;  //35; // hack, da falsch hinterlegt
                                this.props.setInteriorSize(this.selectedobject.userData.width, this.selectedobject.userData.height, this.selectedobject.userData.depth); /// TODO: allgemein
                                await ThreeUtils.setTransformations(this.scene, this.selectedobject.userData.calculationModel, this.selectedobject, this.selectedobject.userData.interior.width, this.selectedobject.userData.interior.height, odepth, owidth, oheight, odepth);
                            }
                            if (ni.type == "door") {
                                this.selectedobject.userData.interior.depth = odepth;// 40;// this.selectedobject.userData.depth;
                                // this.selectedobject.userData.width = this.selectedobject.userData.interior.width;
                                // this.selectedobject.userData.height = this.selectedobject.userData.interior.height;

                                this.props.setInteriorSize(this.selectedobject.userData.interior.width, this.selectedobject.userData.interior.height, this.selectedobject.userData.depth); /// TODO: allgemein
                                await ThreeUtils.setTransformations(this.scene, this.selectedobject.userData.calculationModel, this.selectedobject, this.selectedobject.userData.interior.width, this.selectedobject.userData.interior.height, this.selectedobject.userData.interior.depth, owidth, oheight, odepth);
                            }
                            this.props.setInteriorPosition(-this.selectedobject.position.x, this.selectedobject.position.y, -this.selectedobject.position.z);
                            await this.setSelectedObject(this.selectedobject, 0xFF6600);
                        }


                    }

                }
                // edited
                if (!(Array.isArray(firstprop))) {
                    if (firstprop.position?.y) {
                        var ypos = firstprop.position.y[0];
                        if (firstprop.position.y.length === 2)
                            ypos = firstprop.position.y[1];
                        try {

                            this.selectedobject.position.y = ypos;
                            if (this.props?.setInteriorPosition)
                                this.props?.setInteriorPosition(-this.selectedobject.position.x, this.selectedobject.position.y, -this.selectedobject.position.z);
                        }
                        catch (e) {

                        }
                    }

                    // position schleife vermeiden
                    if (!firstprop.position) {
                        if (firstprop.scale) {
                            if (firstprop.scale.z)
                                (this.selectedobject as Mesh).scale.x = firstprop.scale.z[1] * Math.abs((this.selectedobject as Mesh).scale.z);
                            if (firstprop.scale.x)
                                (this.selectedobject as Mesh).scale.z = firstprop.scale.x[1] * Math.abs((this.selectedobject as Mesh).scale.x);
                        }
                        if (firstprop.rotate) {
                            var rotate = firstprop.rotate[0];
                            if (firstprop.rotate.length === 2)
                                rotate = firstprop.rotate[1];
                            (this.selectedobject as Mesh).rotation.y = (Math.PI / 180 * rotate);
                        }

                        // objektmaße
                        var originalwidth = this.selectedobject.userData.originalwidth;
                        var originalheight = this.selectedobject.userData.originalheight;
                        var originaldepth = this.selectedobject.userData.originaldepth;
                        var width = this.selectedobject.userData.width;
                        var height = this.selectedobject.userData.height;
                        var depth = this.selectedobject.userData.depth;
                        if (firstprop.width) {
                            width = firstprop.width[0];
                            if (firstprop.width.length === 2)
                                width = firstprop.width[1];
                            this.selectedobject.userData.width = width;
                        }
                        if (firstprop.height) {
                            height = firstprop.height[0];
                            if (firstprop.height.length === 2)
                                height = firstprop.height[1];
                            this.selectedobject.userData.height = height;
                        }
                        if (firstprop.depth) {
                            depth = firstprop.depth[0];
                            if (firstprop.depth.length === 2)
                                depth = firstprop.depth[1];
                            this.selectedobject.userData.depth = depth;

                        }
                        if (firstprop.width || firstprop.height || firstprop.depth) {
                            await ThreeUtils.setTransformations(this.scene, this.selectedobject.userData.calculationModel, this.selectedobject, width, height, depth, originalwidth, originalheight, originaldepth);
                        }

                        // fenster, Türen
                        if (firstprop.wall) {
                            console.log('edit wall', firstprop.wall)
                            var w = firstprop.wall[0];
                            if (firstprop.wall.length === 2)
                                w = firstprop.wall[1];
                            (this.selectedobject as Mesh).userData.wallindex = w;

                            var insertpoint = await Utils.calcWallInsertPoint(this.props.walls, this.selectedobject, true, this.props.interiors, w);
                            //  console.log('insertpoint', insertpoint)
                            this.selectedobject.position.set(insertpoint.x, this.selectedobject.position.y, insertpoint.z);
                            this.selectedobject.rotation.y = insertpoint.rot;
                            this.selectedobject.userData.wallindex = insertpoint.wall;
                            this.selectedobject.updateMatrix();

                            this.props.setInteriorPosition(-this.selectedobject.position.x, this.selectedobject.position.y, -this.selectedobject.position.z, this.selectedobject.userData.wallindex);
                        }

                        await this.setSelectedObject(this.selectedobject, 0xFF6600);
                        //
                        //                        this.findFreeWallPosition(this.selectedobject);
                        //                      // this.props.setSelectedInteriorId(this.selectedobject.userData?.interior?.id);
                        //                    this.props.setInteriorPosition(-this.selectedobject.position.x, this.selectedobject.position.y, -this.selectedobject.position.z);
                        //                      this.setSelectedObject(this.selectedobject, 0xFF6600);
                    }
                }
                // removed
                if (prelastkey[0] == "_") {
                    var obj = diff.interiors[Object.keys(diff?.interiors)[propslength - 1]][0];;
                    if (this.scene)
                        this.scene.traverse((child => {
                            var idtodel = firstprop.id;
                            if (Array.isArray(firstprop.id))
                                idtodel = firstprop.id[0];
                            if (!idtodel) idtodel = obj.id
                            if (child?.userData?.interior?.id === idtodel) {
                                for (var i = 0; i < this.meshes.length; i++) {
                                    if (this.meshes[i].userData?.interior?.id === idtodel) {
                                        this.meshes.splice(i, 1);
                                        break;
                                    }
                                }
                                this.scene.remove(child);
                                if (this.selectBoxHelper)
                                    this.scene.remove(this.selectBoxHelper);
                                this.setSelectedObject(null, 0xFF6600)
                            }
                        }));
                }
            }
            catch (e) {
                console.log(e)
            }

        }




        if (diff?.canvasView?.length > 1) {
            if (diff?.canvasView[1] == "2d") {
                this.orthoView();
            }
            if (diff?.canvasView[1] == "3d") {
                this.innerView();

                var ci = this.props?.cameraIndex - 1; // this.viewpoints.length - diff?.cameraIndex[1];
                // if (ci == this.viewpoints.length) ci = 0;
                // if (this.props.walls.length === 3) {// offener Raum
                //     ci = diff?.cameraIndex[1] - 1;
                //     if (ci == -1) ci = 3;
                // }                this.setCamera(this.viewpoints[ci]);
                //              console.log('set camera2', ci)
                this.setCamera(this.viewpoints[ci]);
                this.resize();
            }
        }

        /////////////// Ansichten schalten

        // bei Decke, andere Möbel dunkler machenster
        if (this.props.selectableTypes[0] === "lamp") {
            this.scene.traverse((child) => {
                var c = child as any;
                if (c instanceof THREE.Mesh) {

                    if (c.userData.type == "child_furniture" || c.userData.type == "furniture") {
                        c.userData.originalColor = JSON.parse(JSON.stringify(c.material.color)).toString(16);
                        c.material.color.set("0x222222");
                        c.material.opacity = 0.1;
                        c.material.transparent = true
                    }
                }
            });
        } else {
            this.scene.traverse((child) => {
                var c = child as any;
                if (c instanceof THREE.Mesh) {

                    if (c.userData.type == "child_furniture" || c.userData.type == "furniture") {
                        c.material.color.set(c.userData.originalColor);//   );
                        c.material.opacity = 1;
                        c.material.transparent = false;
                    }
                }
            });
        }

        console.log('this.props.selectableTypes[0]', this.props.selectableTypes[0])
        if (diff?.selectableTypes) {

            if (this.props.selectableTypes[0]) {

                if (this.props.selectableTypes[0] == "product") {
                    console.log('traverse products')
                    this.scene.traverse((child) => {
                        var c = child as any;
                        if (c) {

                            if (c.userData?.mountingSurface == "ceiling") {
                                c.visible = true;
                            }

                            // if (c.userData?.type)
                            if (c.userData?.type == "windowhelper") {
                                c.visible = false;
                            }

                        }
                    });
                    this.renderer.render(this.scene, this.camera);
                    this.resize();
                }
            }
            else {
                console.log('traverse non products')

                this.scene.traverse((child) => {
                    var c = child as any;
                    if (c) {

                        if (c.userData?.mountingSurface == "ceiling") {
                            //      console.log(c.userData?.mountingSurface)

                            c.visible = false;

                        }
                    }
                });
            }
        }

    }


    render() {

        return <div id="threecontainer" >        </div>;
    }

}

export default ThreeCanvas;
